export const pt = {
  CONTINUE: 'Prosseguir',
  SECURE: 'Seguro',
  PRIVATE: 'Privado',
  LOADING_DATA: 'Carregando dados',
  'IS REQUIRED': 'É necessário',
  SEARCH: 'Procurar',
  Search: 'Procurar',
  SUBMIT: 'Enviar',
  OK: 'Ok',
  'No options available': 'Nenhuma opção disponível',
  'Resource not found.': 'Recurso não encontrado.',
  'Internal error.': 'Erro interno.',
  'Invalid credentials.': 'Credenciais inválidas.',
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  Inactive: 'Inativo',
  STARTER: 'INICIANTE',
  PLUS: 'PLUS',
  SCALE: 'ESCALA',
  PRODUCTION: 'PRODUÇÃO',
  SANDBOX: 'SANDBOX',
  General: 'Geral',
  Institutions: 'Instituições',
  Accounts: 'Contas',
  'Cash position': 'Posição de caixa',
  Transactions: 'Transações',
  Transaction: 'Transação',
  Developers: 'Desenvolvedores',
  'API Activity': 'Atividade da API',
  'API Keys': 'Chaves de API',
  'API Logs': 'Registros de API',
  Webhooks: 'Webhooks',
  'Relevant Links': 'Atalhos',
  Widget: 'Widget',
  'Guides and docs': 'Guias e documentos',
  'My profile': 'Meu perfil',
  Company: 'Companhia',
  'Change environment': 'Alterar ambiente',
  'Your financial ecosystem through a single API.': 'Seu ecossistema financeiro por meio de uma única API.',
  Welcome: 'Bem-vindo!',
  'back!': 'de novo!',
  'Business Email': 'Email Comercial',
  'Company domain': 'Domínio da empresa',
  Password: 'Senha',
  Login: 'Conecte-se',
  'Login to an external account': 'Conecte-se a uma conta externa',
  'You have an external account enabled': 'Você tem uma conta externa habilitada',
  'You have no an external account enabled': 'Você não tem uma conta externa habilitada',
  Or: 'Ou',
  'Forgot your password?': 'Esqueceu sua senha?',
  "Don't have an account?": 'Não tem uma conta?',
  'Sign up': 'Inscrever-se',
  '© {{year}} Datanomik. All rights reserved.': '© {{year}} Datanomik. Todos os direitos reservados.',
  "It's ok, it happens sometimes. Please enter your email address and we'll send you a link to choose a new one.": 'Tudo bem, às vezes acontece. Digite seu endereço de e-mail e enviaremos um link para você escolher um novo.',
  'Send me a reset link': 'Envie-me um link de redefinição',
  'Enter Verification Code': 'Digite o código de verificação',
  Verification: 'Verificação',
  'Enter the verification code that has been sent to {{email}}': 'Digite o código de verificação que foi enviado para <strong>{{email}}</strong>',
  'The code sent is valid for 60 minutes.': 'Este código é válido por 60 minutos. Alguns usuários do Outlook podem ter atrasos para receber o e-mail de confirmação. Por favor, verifique sua pasta de SPAM.',
  "Don't receive the Code?": 'Não recebeu o Código?',
  'Verify Code': 'Código de verificação',
  'Verify Email': 'Verificar E-mail',
  'Account successfully verified!': 'Conta verificada com sucesso!',
  'Verification code resended!': 'Código de verificação reenviado!',
  'Resend Code': 'Reenviar código',
  'Resend email': 'Reenviar email',
  'The password must contain at least {{count}} lowercase alphabetical characters.': 'A senha deve conter pelo menos {{count}} caracteres alfabético minúsculos.',
  'The password must contain at least {{count}} uppercase alphabetical characters.': 'A senha deve conter pelo menos {{count}} caracteres alfabético maiúsculos.',
  'The password must contain at least {{count}} numeric characters.': 'A senha deve conter pelo menos {{count}} caracteres numéricos.',
  'The password must contain at least {{count}} special characters.': 'A senha deve conter pelo menos {{count}} caracteres especiales.',
  'The password must be {{count}} characters or longer.': 'A senha deve ter {{count}} caracteres ou mais.',
  'The password has expired and needs to be updated.': 'A senha expirou e precisa ser atualizada.',
  'Please make sure your passwords match.': 'Verifique se suas senhas correspondem.',
  'URL must start with https://': 'O URL deve começar com https://',
  Finance: 'Financeiro',
  FINANCE: 'Financeiro',
  VIEW_FINANCE: 'Financeiro',
  OPERATOR: 'Operador',
  Operations: 'Operações',
  Product: 'Produto',
  Other: 'Outro',
  'Small business': 'Pequeno porte',
  'Medium business': 'Médio porte',
  'Large enterprise': 'Grande porte',
  'Financial institution': 'Instituição financeira',
  'Public sector': 'Setor Público',
  Companies: 'Empresas',
  Individuals: 'Indivíduos',
  Both: 'Ambos',
  'Bank / Neobank': 'Banco / Neobanco',
  Contability: 'Contabilidade',
  'Financial management': 'Gestão financeira',
  'Identity verification': 'KYC',
  Insurance: 'Seguro',
  Investment: 'Investimento',
  Lending: 'Crédito',
  Onboarding: 'Onboarding',
  Payments: 'Pagamentos',
  'Investment Movements': 'Movimentos de Investimentos',
  'Payment receipt': 'Comprovantes',
  'Payments receipt': 'Comprovantes',
  'Payments Receipts successfully requested!': 'Pedido de comprovante realizado com sucesso!',
  'Payments receipts': 'Comprovantes',
  'Request Payment Receipt': 'Solicitar comprovante',
  'Payment Receipt successfully download!': 'Comprovante baixado com sucesso!',
  'View Requested Payment Receipts list': 'Ver lista',
  '{{count}} Requested Payment Receipts': '{{count}} Comprovantes',
  'Next request': 'Próxima busca',
  'Requested Payment Receipts': 'Pedidos de Comprovantes',
  downloadableSince: 'Descargable desde',
  'Requested at': 'Solicitado em',
  'Bulk actions': 'Ações em massa',
  'Unrequest Payment Receipt': 'Remova a solicitação de Comprovantes',
  'Payments Receipts successfully download!': 'Comprovantes baixados com sucesso!',
  'Payments Receipts successfully unrequested!': 'Pedido de Comprovante removida com sucesso!',
  'The selected payments have no receipts generated.': 'Os pagamentos selecionados não têm comprovantes gerados.',
  'Some of the selected payments have no receipts generated and will be omitted.': 'Alguns dos pagamentos selecionados não têm comprovantes gerados e serão omitidos.',
  'The selected payments already have receipts generated.': 'Os pagamentos selecionados já têm comprovantes gerados.',
  'Some of the selected payments already have receipts generated and will be omitted.': 'Alguns dos pagamentos selecionados já têm comprovantes gerados e serão omitidos.',
  'The selected payments do not have requested receipts.': 'Os pagamentos selecionados não têm comprovantes solicitados.',
  'Some of the selected payments do not have requested receipts and will be omitted.': 'Alguns dos pagamentos selecionados não têm comprovantes solicitados e serão omitidos.',
  Reconciliation: 'Reconciliação',
  'Investment diversification': 'Diversificação dos investimentos',
  'Less than 1hs': 'Menos de 1h',
  '1 to 6hs': '1 a 6h',
  '6 to 12hs': '6 a 12h',
  'More than 12hs': 'Mais de 12h',
  'API docs': 'Documentos da API',
  'Contact us': 'Contate-Nos',
  'Connect your business to the financial ecosystem': 'Conecte sua empresa ao ecossistema financeiro',
  'Centralize your cash management and gain a comprehensive financial view.': 'Centralize a gestão da tesouraria e obtenha uma <strong>visão financeira completa.</strong>',
  'Sign up and get a free trial in just a few minutes. Visualize all your bank accounts in a single web platform.': 'Cadastre-se e obtenha um teste gratuito em apenas alguns minutos. Visualize todas as suas contas bancárias em uma única plataforma web.',
  'Create an account and get a free trial in just a few minutes. No credit card required.': 'Crie uma conta e obtenha uma avaliação gratuita em apenas alguns minutos. Não é necessário cartão de crédito.',
  'Start building in our Sandbox environment with sample data.': 'Comece a construir em nosso ambiente Sandbox com dados de amostra.',
  'Try out our APIs and features without coding a single line:': 'Experimente nossas APIs e recursos sem codificar uma única linha:',
  'Identity.': 'Identidade.',
  'Accounts.': 'Contas.',
  'Balances.': 'Saldos.',
  'Transactions.': 'Transações.',
  'Retrieve real financial information for up to 25 free live links.': 'Recupere informações financeiras reais para até 25 links ao vivo gratuitos.',
  'First Name': 'Primeiro nome',
  'Last Name': 'Último nome',
  Country: 'País',
  "I accept Datanomik's": 'Eu aceito a Datanomic',
  'I accept Datanomiks Terms and Conditions and Privacy Policy.': 'Aceito os <2>Termos e Condições</2> e a <6>Politica de Privacidade</6>.',
  'I agree to the use and processing of my data by Datanomik (Uruguay and Brazil) for commercial purposes and for the improvement of its services.': 'Concordo com o uso e o processamento de meus dados pela Datanomik (Uruguai e Brasil) para fins comerciais e para a melhoria de seus serviços.',
  'Terms and Conditions': 'Termos e Condições',
  and: 'e',
  'Privacy Policy.': 'Política de Privacidade.',
  'Create my account': 'Criar a minha conta',
  'Company name': 'Nome da empresa',
  'Countries of operation': 'Países de operação',
  'Country of operation': 'País de operação',
  Mobile: 'Contato',
  'Work area': 'Área de trabalho',
  'Company type': 'Tamanho de empresa',
  'Your clients are': 'Seus clientes estão',
  'Use case': 'Caso de uso',
  'Number of Institutions': 'Número de instituições',
  'Refresh rate': 'Atualização',
  'New Password': 'Nova Senha',
  'Repeat New Password': 'Repita a nova senha',
  'Repeat Password': 'Repita a senha',
  'Change Password': 'Mudar senha',
  'Help is on the way, please check your email for further instructions.': 'A ajuda está a caminho, verifique seu e-mail para obter mais instruções.',
  "You haven't added a Link yet.": 'Você ainda não adicionou um Link.',
  'Add link': 'Adicionar link',
  Actions: 'Ações',
  Institution: 'Instituição',
  Type: 'Tipo',
  Description: 'Descrição',
  description: 'Descrição',
  'Last update': 'Última atualização',
  Detail: 'Detalhe',
  Edit: 'Editar',
  Delete: 'Excluir',
  Add: 'Adicionar',
  'Account detail': 'Detalhes da conta',
  'Investments detail': 'Detalhes dos investimentos',
  'Delete Link': 'Excluir Link',
  Confirmation: 'Confirmação',
  'Are you sure you want to delete this Link?': 'Tem certeza de que deseja excluir este Link?',
  'Are you sure you want to delete this User?': 'Tem certeza de que deseja excluir este Usuário?',
  'Are you sure you want to delete this Account?': 'Tem certeza de que deseja excluir a conta?',
  'Edit Link': 'Editar Link',
  'Add a Link': 'Adicionar um Link',
  'Links exported successfully!': 'Links exportadas com sucesso!',
  'Transactions exported successfully!': 'Transações exportadas com sucesso!',
  'Link edited successfully!': 'Link editado com sucesso!',
  'Account edited successfully!': 'Conta editada com sucesso!',
  'Category group edited successfully!': 'Grupo de categoria editado com sucesso!',
  'General Owner edited successfully!': 'Grupo de Proprietário editado com sucesso!',
  'Owner edited successfully!': 'Proprietário editado com sucesso!',
  'Account updated successfully!': 'Conta atualizada com sucesso!',
  'Category group deleted successfully!': 'Grupo de categoria excluído com sucesso!',
  'Link deleted successfully!': 'Link excluído com sucesso!',
  'Account deleted successfully!': 'Conta excluída com sucesso!',
  Bank: 'Banco',
  'Link updated successfully!': 'Link atualizada com sucesso!',
  'Link created successfully!': 'Link criada com sucesso!',
  'Select Country': 'Selecione o país',
  'Select Institution': 'Selecionar instituição',
  Business: 'O negócio',
  Authentication: 'Autenticação',
  Back: 'Voltar',
  Save: 'Salvar',
  'Credentials not configured yet': 'Credenciais ainda não configuradas',
  'Edit credentials': 'Editar credenciais',
  'More fields': 'Mais campos',
  'Fill in manually': 'Preencher manualmente',
  'Scan QR code': 'Escanear o código QR',
  'Upload QR code': 'Fazer upload do código QR',
  'Manually fill in the digits of the token.': 'Digite manualmente os dígitos do token',
  'Activate the camera and scan the QR code.': 'Ative a câmera e escaneie o código QR.',
  'Upload a file containing the QR code.': 'Carregue um arquivo que contenha o código QR.',
  'Requesting camera permissions...': 'Solicitando permissões de câmera...',
  'Scan Qr try again': 'Verifique se o seu dispositivo possui uma câmera e se ela está ativada<br /><2>Tente novamente</2>.',
  'Click here to upload the file with the QR code': 'Clique aqui para carregar o arquivo com o QR',
  'Virtual account': 'Conta virtual',
  Cancel: 'Cancelar',
  'Copied!': 'Copiado!',
  'Virtual accounts': 'Contas virtuais',
  'Created at': 'Criado em',
  'Accessed at': 'Acessado em',
  Yes: 'Sim',
  No: 'Não',
  User: 'Do utilizador',
  Name: 'Nome',
  Email: 'E-mail',
  Address: 'Endereço',
  Account: 'Conta',
  Phone: 'Telefone',
  of: 'de',
  Owner: 'Proprietário',
  'Owner Name': 'Nome do proprietário',
  'Type and Number': 'Tipo e Número',
  Status: 'Status',
  'Link status': 'Status do Link',
  Active: 'Ativo',
  Available: 'Disponível',
  SUCCESS: 'Disponível',
  'Available Balance': 'Saldo disponível',
  'Available balance': 'Saldo disponível',
  'Current balance': 'Saldo atual',
  'Current Balance': 'Saldo atual',
  'Account current balance': 'Saldo atual',
  'Investments Gross Value': 'Investimentos Saldo Bruto',
  'Account available balance': 'Saldo disponível',
  'Investments Net Value': 'Saldo aplicado',
  Currency: 'Moeda',
  Filters: 'Filtros',
  Export: 'Exportar',
  Filter: 'Filtrar',
  Clear: 'Apagar',
  Columns: 'Colunas',
  Density: 'Densidade',
  "Institution's description": 'Descrição da instituição',
  active: 'ativo',
  inactive: 'inativo',
  'Invalid credentials': 'Credenciais inválidas',
  Date: 'Data',
  Amount: 'Valor',
  'Initial amount': 'Valor inicial',
  'Initial date': 'Data inicial',
  Balance: 'Saldo',
  Reference: 'Referência',
  reference: 'Referência',
  'Select a Date Range': 'Selecione um intervalo de datas',
  Apply: 'Aplicar',
  Today: 'Hoje',
  Tomorrow: 'Amanhã',
  Yesterday: 'Ontem',
  at: 'às',
  'Last 15 minutes': 'Últimos 15 minutos',
  'Last 30 minutes': 'Últimos 30 minutos',
  'Last 1 hour': 'Última 1 hora',
  'Last 4 hours': 'Últimas 4 horas',
  'Last 12 hours': 'Últimas 12 horas',
  'Last 24 hours': 'Últimas 24 horas',
  'Last 48 hours': 'Últimas 48 horas',
  'Last 3 days': 'Últimos 3 dias',
  'Last 5 days': 'Últimos 5 dias',
  'Last 7 days': 'Últimos 7 dias',
  'Last 30 days': 'Últimos 30 dias',
  'Last 1 month': 'Último mês',
  'This Month': 'Este mês',
  'Last Month': 'Mês passado',
  'Quick filter': 'Filtro rápido',
  'Log out': 'Sair',
  Generate: 'Gerar',
  "You haven't generated a webhook yet.": 'Você ainda não gerou um webhook.',
  'Delete Webhook': 'Excluir webhook',
  'Are you sure you want to delete this Webhook?': 'Tem certeza de que deseja excluir este Webhook?',
  'Edit webhook': 'Editar webhook',
  'Generate a webhook': 'Gerar um webhook',
  'Webhook deleted successfully!': 'Webhook excluído com sucesso!',
  'Webhook edited successfully!': 'Webhook editado com sucesso!',
  'Webhook created successfully!': 'Webhook criado com sucesso!',
  Events: 'Eventos',
  Verified: 'Verificado',
  TRANSACTIONS: 'Transações',
  transactions: 'Transações',
  ACCOUNTS: 'Contas',
  accounts: 'Contas',
  ACCOUNTS_VERIFICATION: 'Verificação de contas',
  accounts_verification: 'Verificação de contas',
  "You don't have any activity yet": 'Você ainda não tem nenhuma atividade',
  'Start building by generating your': 'Comece a construir gerando suas',
  'Request Details': 'Pedir detalhes',
  Response: 'Resposta',
  Success: 'Sucesso',
  Failure: 'Fracasso',
  Method: 'Método',
  Resource: 'Recurso',
  Source: 'Fonte',
  'IP Address': 'Endereço de IP',
  Resources: 'Recursos',
  'All Resources': 'Todos os recursos',
  'All Methods': 'Todos os métodos',
  'All Sources': 'Todas as fontes',
  'All Status': 'Todos os status',
  'Response code': 'Código de resposta',
  'All Response Codes': 'Todos os códigos de resposta',
  Balances: 'Saldos',
  balances: 'saldos',
  BALANCES: 'SALDOS',
  owners: 'Proprietários',
  Owners: 'Proprietários',
  'label.owners': 'Proprietários',
  OWNERS: 'PROPRIETÁRIOS',
  PLATFORM: 'Plataforma',
  'Credential successfully created!': 'Credencial criada com sucesso!',
  'Credential successfully saved!': 'Credencial salva com sucesso!',
  'Credential successfully deleted!': 'Credencial excluída com sucesso!',
  'Create Date': 'Criar Data',
  'Save changes': 'Salvar',
  'Generate up to 5 API Keys.': 'Gere até 5 API Keys.',
  'Generate API Keys': 'Gerar chaves de API',
  'Start building by generating up to 5 API Keys.': 'Comece a construir gerando até 5 chaves de API.',
  'Are you sure you want to delete this API Key?': 'Tem certeza de que deseja excluir esta chave de API?',
  'Delete Key': 'Excluir chave',
  'Before deleting this API Key, we first recommend you to generate a new one and update your applications.': 'Antes de excluir esta chave de API, primeiro recomendamos que você gere uma nova e atualize seus aplicativos.',
  'New credential created': 'Nova credencial criada',
  'We recommend you not to share this information to anyone and also change it from time to time.': 'Recomendamos que você não compartilhe essas informações com ninguém e também as altere de tempos em tempos.',
  'This is the only time the secret password can be viewed. Please copy it and/or download both secrets. If you forgot doing so, you can always create a new API Key.': 'Esta é a única vez que a senha secreta pode ser visualizada. Por favor, copie-o e/ou baixe ambos os segredos. Se você esqueceu de fazer isso, sempre pode criar uma nova chave de API.',
  'Secret Password': 'Senha Secreta',
  'Secret ID': 'Código secreto',
  'Download CSV': 'Baixar CSV',
  'More Filters': 'Mais filtros',
  Contact: 'Contato',
  Role: 'Função',
  'Invite a member': 'Convidar um membro',
  'Invite an User': 'Convide um usuário',
  Disable: 'Desativar',
  Enable: 'Habilitar',
  'Send invite': 'Mandar convite',
  'Edit User': 'Editar usuário',
  bank: 'banco',
  all: 'todos',
  All: 'Todos',
  '~ALL~': 'Todos',
  ALL: 'TODOS',
  'Enter Password': 'Digite a senha',
  'User successfully enabled!': 'Usuário ativado com sucesso!',
  'User successfully disabled!': 'Usuário desativado com sucesso!',
  'User successfully invited!': 'Usuário convidado com sucesso!',
  'User successfully saved!': 'Usuário salvo com sucesso!',
  'User successfully deleted!': 'Usuário excluído com sucesso!',
  'Company saved succefully!': 'Dados da empresa salvos com sucesso!',
  'Company updated succefully!': 'Dados da empresa atualizados com sucesso!',
  'Password changed succefully!': 'Senha alterada com sucesso!',
  'Profile saved succefully!': 'Perfil salvo com sucesso!',
  'View Details': 'Ver detalhes',
  'View details': 'Ver detalhes',
  Free: 'Livre',
  '{{freeTrialPeriod}}-days free trial': '{{freeTrialPeriod}} dias de avaliação gratuita',
  '{{currency}} {{monthlyCost}}/Month': '{{currency}} {{monthlyCost}}/mês',
  'Including:': 'Incluindo:',
  'Sandbox environment': 'Ambiente de sandbox',
  '{{maxPlanIncludedSynCalls}} successful sync calls': '{{maxPlanIncludedSynCalls}} chamadas de sincronização bem-sucedidas',
  'Standard customer service': 'Atendimento ao cliente padrão',
  'Dedicated account manager': 'Gerente de contas dedicado',
  'For additional calls, pay as you go {{currency}} {{exceededPlanSynCallCost}}0 per successful sync call.': 'Para chamadas adicionais, pague conforme o uso {{currency}} {{exceededPlanSynCallCost}}0 por chamada de sincronização bem-sucedida.',
  Plans: 'Planos',
  Subscription: 'Inscrição',
  'Most Popular!': 'Mais popular!',
  'Subscription end date': 'Data de término da assinatura',
  'Your subcription will be automatically renewed each month': 'Sua assinatura será renovada automaticamente a cada mês',
  'Available Plans': 'Planos disponíveis',
  Plus: 'Plus',
  'Upgrade Now': 'Atualize agora',
  'Upgrade now': 'Atualize agora',
  Scale: 'Escala',
  'Get a custom plan and dedicated support!': 'Obtenha um plano personalizado e suporte dedicado!',
  'Contact Sales': 'Entre em contato com vendas',
  'Payment method': 'Forma de pagamento',
  'Card number': 'Número do cartão',
  'Document name': 'Nome do Documento',
  'Document number': 'Número do documento',
  'Scale Plan': 'Plano de Escala',
  'Upgrade Confirmation': 'Confirmação de atualização',
  'Successful upgrade': 'Atualização bem-sucedida',
  'Thanks for contacting us, we will contact you as soon as possible': 'Obrigado por entrar em contato conosco, entraremos em contato o mais breve possível',
  Starter: 'Iniciante',
  'Active Plan': 'Plano Ativo',
  'Pending Plan': 'Plano pendente',
  'Expired Plan': 'Plano expirado',
  Days: 'Dias',
  '{{cantDays}} of {{totalDays}}': '{{cantDays}} de {{totalDays}}',
  '{{daysRemaining}} days remaining': '{{daysRemaining}} dias restantes',
  "We'll contact you to build up the right plan for your business, including:": 'Entraremos em contato com você para criar o plano certo para o seu negócio, incluindo:',
  'More refresh frequency!': 'Mais frequência de atualização!',
  'Select a company type': 'Selecione um tipo de empresa',
  'Select a frequency interval': 'Selecione um intervalo de frequência',
  'Refresh Frequency': 'Frequência de atualização',
  'Select a use case scenario': 'Selecione um cenário de caso de uso',
  'Elaborate on why you need these specific things...': 'Explique por que você precisa dessas coisas específicas...',
  'Tell us more about your specific needs': 'Conte-nos mais sobre suas necessidades específicas',
  'Purchase summary': 'Resumo da compra',
  'Proceed to checkout': 'Fazer o check-out',
  'Cardholder name': 'Nome do Titular',
  'Card Number': 'Número do cartão',
  'Expiration Date': 'Data de validade',
  Pay: 'Pagar',
  Continue: 'Continuar',
  'Save and continue': 'Salvar e continue',
  'API Calls': 'Chamadas de API',
  'API call evolution': 'Evolução de chamadas de API',
  'Success calls': 'Chamadas de sucesso',
  'Failed calls': 'Falha nas chamadas',
  'Total calls': 'Total de chamadas',
  'Session expired': 'Sessão expirada',
  Unauthorized: 'Não autorizado',
  Monthly: 'Por mês',
  'Success Rate': 'Taxa de sucesso',
  Failed: 'Fracasso',
  Recurrent: 'Recorrente',
  'One-shot': 'One-shot',
  Compact: 'Compactar',
  Standard: 'Padrão',
  Comfortable: 'Confortável',
  'Find column': 'Localizar coluna',
  'Column title': 'Título da coluna',
  'Reorder column': 'Reordenar coluna',
  'Show all': 'Mostrar tudo',
  'Hide all': 'Esconda tudo',
  assets: 'assets',
  Assets: 'Assets',
  ASSETS: 'ASSETS',
  LINKS: 'Links',
  'Upgrade your plan for more links and data synchronizations.': 'Atualize seu plano para mais links e sincronizações de dados.',
  'Total Links': 'Total de links',
  'Up to {{maxRecurrentLink}} recurrent link/s with {{refreshFrequency}}hs refresh frequency': 'Até {{maxRecurrentLink}} links recorrentes com {{refreshFrequency}}hs frequência de atualização',
  'Unlimited test links': 'Links de teste ilimitados',
  Links: 'Links',
  links: 'Links',
  Live: 'Live',
  'C-Level': 'Nível C',
  'Live demo': 'Demonstração ao vivo',
  TI: 'Desenvolvedor',
  'Extra recurrent links': 'Links recorrentes extras',
  'Recurrent Links/Month': 'Links recorrentes/mês',
  'Total Current Balance': 'Saldo Atual Total',
  'First name': 'Primeiro nome',
  'Last name': 'Último nome',
  'Second last name': 'Segundo sobrenome',
  'Change credentials': 'Alterar credenciais',
  'Upgrade plan now': 'Atualize seu plano agora',
  'Your subscription has expired on {{validUntil}}.': 'Sua assinatura expirou em {{validUntil}}.',
  'Your subscription will expire on {{validUntil}}.': 'Sua assinatura expirará em {{validUntil}}.',
  'Until {{validUntil}}': 'Até {{validUntil}}',
  'Access denied': 'Acesso negado',
  '7 days': '7 dias',
  '15 days': '15 dias',
  '30 days': '30 dias',
  'Current month': 'Mês atual',
  'No options': 'Sem opções',
  Loading: 'Carregando...',
  'Basic Information': 'Informação básica',
  Next: 'Próximo',
  Submit: 'Enviar',
  'Write at least 3 characters to start searching': 'Escreva pelo menos 3 caracteres para começar a pesquisar',
  'We were unable to link the Institution': 'Não foi possível vincular a Instituição',
  'Please verify the information filled in and try again.': 'Verifique as informações preenchidas e tente novamente.',
  'Try again': 'Tente novamente',
  'We are processing the transactions. This can take a few seconds.': 'Estamos processando as transações. Isso pode levar alguns segundos.',
  'Validating credentials': 'Validando suas credenciais',
  "We're almost done! This can take a few seconds.": 'Estamos quase terminando! Isso pode levar alguns segundos.',
  "Please don't close this window.": 'Por favor, não feche esta janela.',
  'The Institution was successfully linked': 'A Instituição foi vinculada com sucesso',
  Profile: 'Perfil',
  'Supports Widget Recurrent Link': 'Suporta Link Recorrente de Widget',
  'No rows found.': 'Nenhuma linha encontrada.',
  'No rows': 'Sem linhas',
  'No results found.': 'Nenhum resultado encontrado.',
  'An error occurred.': 'Um erro ocorreu.',
  'No occurrences': 'Sem ocorrências',
  occurrences: 'ocorrências',
  'General account status': 'Status gerais das contas',
  Sender: 'Remetente',
  SENDER: 'Remetente',
  SENDER_DOCUMENT: 'Documento do remetente',
  'Sender detail': 'Detalhes do remetente',
  senderName: 'Remetente',
  Beneficiary: 'Beneficiário',
  BENEFICIARY: 'Beneficiário',
  BENEFICIARY_DOCUMENT: 'Documento do beneficiário',
  'Beneficiary detail': 'Detalhes do beneficiário',
  beneficiaryName: 'Beneficiário',
  PI_TYPE: 'Instituição de pagamento',
  BANK_TYPE: 'Instituição bancária',
  OF_TYPE: 'Open Finance',
  'Please confirm us the following information': 'Por favor, confirme-nos as seguintes informações',
  'Growth Plan': 'Growth Plan',
  'Custom Plan': 'Custom Plan',
  'Get a tailored plan for your business': 'Obtenha um plano personalizado para o seu negócio',
  'Grow your business with our pay-as-you-go plan': 'Expanda seus negócios e pague apenas pelo que usa',
  'The first {{freeTrialPeriod}} days are on us!': 'Os primeiros {{freeTrialPeriod}} dias são por nossa conta!',
  'More data synchronization / month': 'Mais sincronização de dados / mês',
  'More refresh frequency': 'Mais frequência de atualização',
  'No contractual minimums': 'Sem mínimos contratuais',
  'Up to {{total}} data synchronizations / month': 'Até {{total}} sincronizações de dados / mês',
  '{{currency}} {{cost}} per synchronization': '{{currency}} {{cost}} por sincronização',
  '{{refreshRate}} hs refresh rate': '{{refreshRate}} hs de taxa de atualização',
  'Requested Plan': 'Plano solicitado',
  Subscribe: 'Se inscrever',
  'Your tailored plan includes:': 'Seu plano personalizado inclui:',
  'Blocked account': 'Conta bloqueada',
  "Visualize your company's financial data in a single web platform.": 'Visualize os dados financeiros da sua empresa em uma única plataforma web.',
  'Other Plans': 'Outros Planos',
  'Add Payment Method': 'Adicionar Forma de Pagamento',
  'Edit Payment Method': 'Editar Forma de Pagamento',
  'Please select your Payment Method.': 'Por favor, selecione sua Forma de Pagamento.',
  'The free trial ends on {{validUntil}}.': 'O período de teste termina em {{validUntil}}.',
  Admin: 'Administrador',
  ADMIN: 'Administrador',
  GENERAL_ADMINISTRATOR: 'Administrador Geral',
  Developer: 'Desenvolvedor',
  DEVELOPER: 'Desenvolvedor',
  'Read only': 'Somente leitura',
  'The information was successfully updated!': 'As informações foram atualizadas com sucesso!',
  Refresh: 'Atualizar',
  'Retrieve Accounts': 'Recuperar Contas',
  'Recovered accounts with success!': 'Contas recuperadas com sucesso!',
  READ_ONLY: 'Somente leitura',
  'Welcome back to Business Gate': 'Seja bem-vindo ao <strong>Datanomik</strong>',
  'Visualize your financial data in a single web platform.': 'Visualize todas as suas contas bancárias em uma única plataforma web.',
  'Understand your company\'s cash flow and make strategic decisions with Datanomik\'s Smart Treasury': 'Entenda o caixa da sua empresa e tome decisões estratégicas com a <4>Tesouraria Inteligente</4> da <2>Datanomik</2>',
  'Have an account?': 'Tem uma conta?',
  'Need a help?': 'Precisa de ajuda?',
  'Talk with us': 'Fale conosco',
  'Sign in': 'Entrar',
  'Create your account': 'Crie sua conta',
  'Log in to your account': 'Entre na sua conta',
  'Welcome back {{firstName}}!': 'Bem-vindo de novo {{firstName}}!',
  'Check out your financial overview': 'Confira sua visão financeira',
  'than last day': 'que no último dia',
  'Last update: {{lastUpdate}}': 'Última atualização: {{lastUpdate}}',
  'Without activity': 'Sem atividade',
  'Current Balance / Institution': 'Saldo Atual / Instituição',
  'Current Balance / Owner': 'Saldo Atual / Proprietário',
  'Current Balance / Country': 'Saldo Atual / País',
  'Current Balance / Owner Tag': 'Saldo Atual / Tag do proprietário',
  'Current Balance / Account Tag': 'Saldo Atual / Tag da conta',
  'Current Balance / Account group': 'Saldo Atual / Grupo da conta',
  'Without data': 'Sem dados',
  Overview: 'Visão global',
  Debits: 'Débitos',
  'in Debits': 'em Débitos',
  Credits: 'Créditos',
  'in Credits': 'em Créditos',
  'Date Range': 'Intervalo de datas',
  'Inflows, outflows and balance evolution': 'Evolução do créditos, débitos e saldo',
  'Balance evolution': 'Evolução do saldo',
  'Inflow per Institution': 'Crédito por Instituição',
  'Outflow per Institution': 'Débito por Instituição',
  Net: 'Líquido',
  'Net position per Institution': 'Posição líquida por instituição',
  'Net position': 'Posição líquida',
  'Total Net position': 'Caixa líquida',
  REQUESTED: 'Requerido',
  Requested: 'Requerido',
  IN_PROGRESS: 'Em andamento',
  PROCESSED: 'Processado',
  Processed: 'Processado',
  Settings: 'Configurações',
  'Link description': 'Descrição do link',
  Link: 'Link',
  Verify: 'Verificar',
  From: 'A partir de',
  To: 'Para',
  Card: 'Cartão',
  'CREDIT: ': 'Cartão',
  TRANSFER: 'Transferência bancária',
  'Bank Transfer': 'Transferência bancária',
  'You are in test mode.': 'Você está em um ambiente de teste.',
  'Please do not enter real bank credentials.': 'Por favor, não insira credenciais bancárias reais.',
  'Yes, continue': 'Sim, continuar',
  'No, go to production': 'Não, ir a produção',
  BANK: 'Banco',
  'Language of preference': 'Idioma de preferência',
  PI: 'Instituição de pagamento',
  Pi: 'Instituição de pagamento',
  pi: 'Instituição de pagamento',
  OF: 'Open Finance',
  Inflow: 'Créditos',
  Outflow: 'Débitos',
  INFLOW: 'Créditos',
  OUTFLOW: 'Débitos',
  'Welcome to Business Gate': 'Bem-vindo ao Business Gate',
  "Set up your dashboard in 3 single steps and centralize your company's financial data in real-time.": 'Configure seu dashboard em apenas 3 passos e centralize as informações financeiras da sua empresa em tempo real.',
  'Connect my institutions': 'Conectar minhas instituições',
  'or try with test data': 'ou use-o com dados de proba',
  'Refresh rate (mins)': 'Taxa de atualização (mins)',
  'The minimum refresh rate is {{min}} minutes': 'A taxa de atualização mínima é de {{min}} minutos',
  'or try with test data on Sandbox environment': 'ou use-o com dados de proba no ambiente Sandbox',
  FIXED_DEPOSIT: 'Depósito fixo',
  'Fixed deposit': 'Depósito fixo',
  'fixed deposit': 'Depósito fixo',
  Expand: 'Expandir',
  Collapse: 'Colapso',
  'Related links': 'Links Relacionados',
  'Related users': 'Usuários relacionados',
  'Virtual links': 'Links virtuais',
  'Add new virtual link': 'Adicionar novo link virtual',
  'Edit virtual link': 'Editar link virtual',
  'Delete Virtual link': 'Excluir link virtual',
  'Are you sure you want to delete this Virtual link?': 'Tem certeza de que deseja excluir este link virtual?',
  'Virtual link successfully deleted!': 'Link virtual excluído com sucesso!',
  'Virtual link successfully!': 'Link virtual criada com sucesso!',
  'Virtual link successfully saved!': 'Link virtual salvo com sucesso!',
  COUNT_SELECTED_zero: '0 selecionado',
  COUNT_SELECTED_one: '1 selecionado',
  COUNT_SELECTED_other: '{{count}} selecionados',
  'Available Links': 'Links disponíveis',
  'Selected Links': 'Links selecionados',
  'Available Users': 'Usuários disponíveis',
  'Selected Users': 'Usuários selecionados',
  'No Data': 'Sem dados',
  'Assign links': 'Atribuir links',
  'Assign users': 'Atribuir usuários',
  '{{x}} account/s with negative balance': '{{x}} conta/s com saldo negativo',
  'Reset link sent!': 'Redefinir link enviado!',
  'Authentication Type': 'Tipo de Autenticação',

  ACCOUNT: 'Conta',
  BALANCE: 'Saldo',
  'Current account balance': 'Saldo conta corrente',
  AMOUNT: 'Valor',
  EQUALS: 'É igual a',
  TRANSACTION: 'Transação',
  PAYMENT: 'Pagamento',
  PAYMENTS: 'Pagamentos',
  INVESTMENT_MOVEMENTS: 'Movimentos de Investimentos',
  PAYMENT_RECEIPT: 'Comprovantes',
  PIX_TRANSACTION: 'Pix',
  PERIOD_STATEMENT: 'Extrato por período',
  MONTHLY: 'Mensal',
  DESCRIPTION: 'Descrição',
  EXTERNAL_ID: 'ID externo',
  CONTAINS: 'Contém',
  NOT_CONTAINS: 'Não contém',
  STARTS_WITH: 'Começa com',
  ENDS_WITH: 'Termina com',
  GREATER_THAN: 'Maior do que',
  LESS_THAN: 'Menos do que',
  BETWEEN: 'Entre',
  REFERENCE: 'Referência',
  Variable: 'Variável',
  Attribute: 'Atributo',
  Condition: 'Condiçao',
  Value: 'Valor',
  Channel: 'Canal',
  Channels: 'Canais',
  'View Rule': 'Ver regra',
  'Are you sure you want to delete this Rule?': 'Tem certeza de que deseja excluir esta regra?',
  'Add new Rule': 'Adicionar nova regra',
  EMAIL: 'Email',
  Notifications: 'Notificações',
  STATUS: 'Status',
  'Roles reference': 'Referência de papéis',
  'can access every module of the platform with all the permissions.': 'pode acessar todos os módulos da plataforma com todas as permissões.',
  'has access to the financial modules of the platform. Can add, edit, refresh and delete links.': 'tem acesso aos módulos financeiros da plataforma. Pode adicionar, editar, atualizar e excluir links.',
  'has access only to the technical modules of the platform.': 'tem acesso apenas aos módulos técnicos da plataforma.',
  "similar to the Finance role, but can't add links.": 'semelhante à função Finanças, mas não pode adicionar links.',
  en: 'Inglês',
  es: 'Espanhol',
  pt: 'Português',

  'Rule created successfully!': 'Regra criada com sucesso!',
  'Rule deleted successfully!': 'Regra excluída com sucesso!',
  'Rule updated successfully!': 'Regra atualizada com sucesso!',
  'Edit Rule': 'Editar regra',
  linkId: 'Descrição do link',
  institutionId: 'Instituição',
  institutionName: 'Instituição',
  ownerId: 'Proprietário',
  generalOwnerId: 'Proprietário',
  type: 'Tipo',
  availableBalanceLte: 'Saldo disponível <=',
  availableBalanceGte: 'Saldo disponível >=',
  currentBalanceGte: 'Saldo atual >=',
  currentBalanceLte: 'Saldo atual <=',
  availablePositionLte: 'Posição disponível <=',
  availablePositionGte: 'Posição disponível >=',
  currentPositionGte: 'Posição atual >=',
  currentPositionLte: 'Posição atual <=',
  accountId: 'Conta',
  currency: 'Moeda',
  dateFrom: 'A partir de',
  dateFromHistory: 'A partir de',
  dateTo: 'Para',
  dateToHistory: 'Para',
  trxType: 'Tipo',
  amountTo: 'Valor <=',
  amountFrom: 'Valor >=',
  feeTo: 'Taxa <=',
  feeFrom: 'Taxa >=',
  source: 'Fonte',
  module: 'Recursos',
  httpMethod: 'Método',
  responseStatus: 'Status',
  httpResponseStatus: 'Código de resposta',
  'Point of Contact': 'Ponto de contato',
  Severity: 'Prioridade',
  Lowest: 'Muito baixa',
  Low: 'Baixa',
  Medium: 'Média',
  High: 'Alta',
  Highest: 'Muito alta',
  'Your credentials are securely encrypted': 'Suas credenciais são criptografadas com segurança',
  'Institution successfully linked!': 'Instituição vinculada com sucesso!',
  "We're processing transactions, this might take a while to reflect on the dashboard.": 'Estamos processando transações. Isso pode demorar um pouco para refletir no painel.',
  'To read the full list please view the account detail': 'Para ler a lista completa, veja os detalhes da conta',
  'If you wish to customize the refresh rate under {{frequency}} min please upgrade to our Custom plan:': 'Para uma frequência inferior a {{frequency}} min, contate-se com nossa equipe de vendas.',
  'You have {{x}} new message/s!': 'Você tem {{x}} novas mensagens!',
  'Mark all as read': 'Marcar tudo como lido',
  'Only show unread': 'Mostrar apenas não lidos',
  History: 'Histórico',
  'View detail': 'Ver detalhe',
  'Mark as unread': 'Marcar como não lido',
  'Mark as read': 'Marcar como lido',
  Close: 'Fechar',
  Credentials: 'Credenciais',
  'Step {{x}}': 'Passo {{x}}',
  Connect: 'Conectar',
  'See all notifications': 'Ver todas as notificações',
  Identification: 'Identificação',
  Rules: 'Regras',
  name: 'Nome',
  value: 'Valor',
  email: 'E-mail',
  resource: 'Variável',
  Module: 'Módulo',
  field: 'Atributo',
  constraint: 'Condiçao',
  severity: 'Prioridade',

  'Billing history': 'Cobrança',
  Period: 'Período',
  Plan: 'Plano',
  Synchronizations: 'Sincronizações',
  'Price (USD)': 'Preço (USD)',
  'Amount (USD)': 'Valor (USD)',

  'The account <strong>{{accountNumber}}</strong> has been blocked by the Institution.': 'A conta <strong>{{accountNumber}}</strong> foi bloqueada pela Instituição.',
  'The account <strong>{{accountNumber}}</strong> has a balance equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> tem um saldo igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> has a balance higher than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> tem um saldo superior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> has a balance lower than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> tem um saldo inferior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> has a balance between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.': 'A conta <strong>{{accountNumber}}</strong> tem um saldo entre {{constraintValue.constraintValueFrom}} e {{constraintValue.constraintValueTo}}.',
  'The account <strong>{{accountNumber}}</strong> has a judicial blocked balance higher than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> tem um saldo bloqueado judicialmente superior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an amount equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um valor igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an amount higher than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com valor superior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an amount lower than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um valor inferior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com valor entre {{constraintValue.constraintValueFrom}} e {{constraintValue.constraintValueTo}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a fee equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma taxa igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a fee higher than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com valor superior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a fee lower than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma taxa inferior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a fee between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com valor entre {{constraintValue.constraintValueFrom}} e {{constraintValue.constraintValueTo}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a reference equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com referência igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma referência que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma referência que não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma referência que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a reference that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma referência que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com ID externo igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com ID externo que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com ID externo não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com ID externo que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with an external ID that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com ID externo que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a description equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma descrição igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a description that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma descrição que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a description that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma descrição não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a description that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma descrição que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a description that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma descrição que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a category equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com uma categoria igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um remetente igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um remetente que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um remetente não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um remetente que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um remetente que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um beneficiário igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um beneficiário que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um beneficiário não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um beneficiário que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um beneficiário que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender\'s document equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento de remetente igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender\'s document that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento do remetente que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender\'s document that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento do remetente não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender\'s document that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento do remetente que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a sender\'s document that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento do remetente que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary\'s document equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento de beneficiário igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary\'s document that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento de beneficiário que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary\'s document that not contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento de beneficiário não contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary\'s document that starts with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento de beneficiário que começa com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a transaction with a beneficiary\'s document that ends with {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou uma transação com um documento de beneficiário que termina com {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with an amount equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com um valor igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with an amount higher than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com valor superior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with an amount lower than {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com um valor inferior a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with an amount between {{constraintValue.constraintValueFrom}} and {{constraintValue.constraintValueTo}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com valor entre {{constraintValue.constraintValueFrom}} e {{constraintValue.constraintValueTo}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a reference equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com referência igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a reference that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com uma referência que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a description equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com uma descrição igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a description that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com uma descrição que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a category equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com uma categoria igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com um beneficiário igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com um beneficiário que contém {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary\'s document equal to {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com um documento de beneficiário igual a {{constraintValue}}.',
  'The account <strong>{{accountNumber}}</strong> registered a payment with a beneficiary\'s document that contains {{constraintValue}}.': 'A conta <strong>{{accountNumber}}</strong> registrou um pagamento com um documento de beneficiário que contém {{constraintValue}}.',

  Approved: 'Aprovada',
  Expired: 'Expirada',
  Created: 'Criada',
  Blocked: 'Bloqueada',
  'User blocked': 'Bloqueado',
  Refused: 'Rejeitado',
  Pending: 'Pendente',

  APPROVED: 'Aprovada',
  EXPIRED: 'Expirada',
  CREATED: 'Criada',
  BLOCKED: 'Bloqueada',
  REFUSED: 'Rejeitado',
  PENDING: 'Pendente',

  'Billing information': 'Informações de pagamento',
  'Please complete the billing information': 'Por favor, preencha as informações de cobrança',
  'Fiscal Number': 'Número fiscal',
  'Billing information successfully saved!': 'Informações de cobrança salvas com sucesso!',
  'Edit Billing information': 'Editar informações de cobrança',
  Never: 'Nunca',
  Conditions: 'Condições',
  Finalize: 'Finalizar',
  'Time from': 'Hora de',
  'Time to': 'Hora até',
  'When condition is met': 'Quando a condição é satisfeita',
  'Assign accounts': 'Atribuir contas',
  'Available accounts': 'Contas disponíveis',
  'Selected accounts': 'Contas selecionadas',
  'Expand all': 'Expandir todos',
  'Collapse all': 'Recolher todos',

  transactionId: 'ID da transação',
  STAGE_ALPHA: 'Alfa',
  STAGE_BETA: 'Beta',
  STAGE_STABLE: 'Estável',
  'Main currency': 'Moeda principal',
  'Set main currency': 'Definir moeda principal',

  'Collapse menu': 'Recolher menu',
  'Expand menu': 'Expandir menu',
  virtualLinkId: 'Link virtual',
  limitDate: 'Data limite',
  'Limit date': 'Data limite',
  'There is no active plan in order to be able to establish a new link.': 'Não há plano ativo para poder estabelecer um novo link.',
  "It appears you don't have permissions to access this page": 'Parece que você não tem permissão para acessar esta página',
  'Back to home page': 'Voltar à página inicial',
  'Invalid username or password': 'Nome de usuário ou senha inválidos',
  Request: 'Solicitar',
  'Request history': 'Solicitar histórico',
  'Date range': 'Período',
  '{{institution}} allows consulting historic information up to {{maxRecoveryMonth}} months.': '{{institution}} permite consultar informações históricas até {{maxRecoveryMonth}} meses.',
  'Select a date range': 'Selecione um intervalo de datas',
  transactionStatus: 'Status da transação',
  Processing: 'Processando',
  'Processing Accounts': 'Processando Contas',
  'Processing Transactions': 'Processando Transações',
  'We are still processing transactions for some Links.': 'Estamos processando transações de alguns Links.',
  'Company details': 'Detalhes da Companhia',
  'Point of contact': 'Ponto de contato',
  'Check Rates': 'Verificar taxas',
  'Currency rates': 'Taxas de câmbio',
  'Historic rates': 'Taxas históricas',
  'We are still processing the accounts and balances.': 'Estamos processando as contas e saldos.',
  'We are still processing the accounts and balances for some Links.': 'Estamos processando as contas e saldos de alguns Links.',
  "We're processing the information, this might take a while to reflect on the dashboard.": 'Estamos processando as informações, isso pode demorar um pouco para refletir no painel.',
  'Let’s get you started with Datanomik, please take a look at the following steps.': 'Para começar a operar com Datanomik, siga os passos abaixo.',
  'Creating a link': 'Criar um link',
  'Three steps are required to create a new link: select country, select institution, and login.': 'Crie um link em apenas 3 passos: selecione um país, selecione uma instituição e faça o login',
  'Create link': 'Criar link',
  '...or test with fake data': '...ou opere com dados de teste',
  Users: 'Usuários',
  'Invite your team to Business Gate and assign roles. They will be able to set up their own accounts.': 'Convide sua equipe para o Business Gate e atribua funções. Eles poderão configurar suas próprias contas.',
  'Invite user': 'Convidar usuário',
  'Invite new user': 'Convidar novo usuário',
  'Connect our APIs': 'Conecte nossas APIs',
  'Developer roles': 'Função de desenvolvedor',
  'Create a developer profile within Business Gate to integrate our APIs.': 'Convide desenvolvedores para integrar nossas APIs.',
  'Create a developer profile': 'Convidar desenvolvedores',
  'Generate up to 5 API Keys and test with sample and real data through a sandbox environment.': 'Gere até 5 API Keys e comece a testar com dados reais e de teste em nosso ambiente Sandbox.',
  'Integrate APIs': 'Integrar APIs',
  'Forget lengthy and costly integrations. Set up Datanomik’s APIs with just a few lines of code.': 'Esqueça as integrações longas, complicadas e de alto custo. As APIs da Datanomik são as mais adaptáveis e seguras do mercado.',
  'Read API docs': 'Veja os API docs',
  CURRENT_BALANCE_GENERAL_OWNER_TAG_INFO_TEXT: 'Este gráfico apresenta como estão distribuídos seus saldos em cada moeda por tag do proprietário .',
  CURRENT_BALANCE_ACCOUNT_TAG_INFO_TEXT: 'Este gráfico apresenta como estão distribuídos seus saldos em cada moeda por tag da conta.',
  CURRENT_BALANCE_ACCOUNT_GROUP_INFO_TEXT: 'Este gráfico apresenta como estão distribuídos seus saldos em cada moeda por grupo da conta.',
  CURRENT_BALANCE_INSTITUTION_INFO_TEXT: 'Este gráfico apresenta como estão distribuídos seus saldos em cada moeda por instituição.',
  CURRENT_BALANCE_GENERAL_OWNER_INFO_TEXT: 'Este gráfico apresenta como estão distribuídos seus saldos em cada moeda por proprietário.',
  CURRENT_BALANCE_COUNTRY_INFO_TEXT: 'Este gráfico apresenta como estão distribuídos seus saldos em cada moeda por país.',
  NET_POSITION_PER_INSTITUTION_INFO_TEXT: 'Este gráfico apresenta a soma dos créditos e débitos por instituição e a posição líquida. Pode aplicar filtros.',
  CREDITS_DEBITS_AND_BALANCE_EVOLUTION_INFO_TEXT: 'Este gráfico apresenta como os créditos, débitos e saldos evoluem ao longo do tempo. Pode aplicar filtros.',
  BALANCE_EVOLUTION_INFO_TEXT: 'Este gráfico apresenta como os saldos evoluem ao longo do tempo. Pode aplicar filtros.',
  TOTAL_CURRENT_BALANCE_INFO_TEXT: 'Esta seção apresenta a soma dos saldos atuais em cada moeda de todos os links. Verifique as atualizações mais recentes.',
  Brazil: 'Brasil',
  Uruguay: 'Uruguai',
  LINK_DESCRIPTION_FIELD_INFO_TEXT: 'Configure uma descrição para esta instituição. Você pode usá-la mais tarde para filtrar ou pesquisar informações facilmente.',
  'I’m not sure which credentials I should use...': 'Não tenho certeza de quais credenciais devo usar...',
  'We use the highest security standards to protect all information end-to-end': 'Usamos os mais altos padrões de segurança para proteger todas as informações de ponta a ponta',
  LINK_MODAL_INFO_TEXT: 'É necessário configurar credenciais para acessar cada instituição. Recomendamos criar um usuário dedicado para uso exclusivo do <strong>Business Gate</strong>.',
  LINK_MODAL_CREDENTIALS_INFO_TEXT: 'Para vincular sua conta, preencha os campos com as mesmas credenciais que você usa para acessar seu banco.',
  'Go Back': 'Voltar',
  'Invalid Email': 'E-mail inválido',
  'Default Virtual link': 'Link virtual padrão',
  VIRTUAL_LINK_INFO_TEXT: 'Esta funcionalidade permite criar grupos de links e conceder acesso aos usuários correspondentes.<br /><br />Usuários com a função <strong>Finanças</strong> ou <strong>Somente Leitura</strong> podem estar vinculados a vários Links Virtuais. Os <strong>Administradores</strong> terão acesso total, sem restrições.',
  DEFAULT_VIRTUAL_LINK_INFO_TEXT: 'Os usuários relacionados terão acesso para visualizar todas as informações financeiras, sem restrições.',
  Categories: 'Categorias',
  Remove: 'Remover',
  'Add Child': 'Adicionar',
  'Add new category': 'Adicione nova categoria',
  Inflows: 'Créditos',
  Outflows: 'Débitos',
  'Are you sure you want to delete this Category?': 'Tem certeza de que deseja excluir esta categoria?',
  'Related rules will also be removed': 'Regras relacionadas também serão removidas.',
  'Subcategories will also be removed': 'As subcategorias também serão removidas.',
  'New category': 'Nova categoria',
  'Parent category': 'Relacionar a uma categoria principal',
  'Parent group': 'Relacionar a um grupo principal',
  Color: 'Cor',
  'Create new rule': 'Criar nova regra',
  'Create new category': 'Criar nova categoria',
  'Edit rule': 'Regra de edição',
  Create: 'Criar',
  'Add a Category group': 'Adicionar um Grupo de categoria',
  'Edit a Category group': 'Editar um Grupo de categoria',
  'Related Categories': 'Relacionar categorias',
  'Are you sure you want to delete this Category rule?': 'Tem certeza de que deseja excluir esta regra de categoria?',
  'Category successfully!': 'Categoria criada com sucesso!',
  'Category successfully saved!': 'Categoria salva com sucesso!',
  'Category rule successfully!': 'Regra de categoria criada com sucesso!',
  'Category rule successfully saved!': 'Regra de categoria salva com sucesso!',
  'Category rule successfully deleted!': 'Regra de categoria excluída com sucesso!',
  'Category successfully deleted!': 'Categoria excluída com sucesso!',
  'Related rules and Subcategories will also be removed': 'Regras e subcategorias relacionadas também serão removidas',
  'Edit transaction categories': 'Editar categorias de transações',
  'Edit Batch payments categories': 'Editar categorias de Pagamentos em lote',
  'Edit Pix categories': 'Editar categorias de Pix',
  'Categories successfully saved!': 'Categorias salvas com sucesso!',
  categoryId: 'Categoria',
  CATEGORY: 'Categoria',
  Category: 'Categoria',
  'Uruguay - CI': 'Uruguai - CI',
  'Argentina - DNI': 'Argentina - DNI',
  'Brasil - CI': 'Brasil - CI',
  'At least one rule is required.': 'Pelo menos uma regra criada é necessária.',

  'Last day balance': 'Saldo do dia anterior',
  'Add users': 'Adicionar usuário',
  'Save and close': 'Salvar e fechar',
  'You can assign the users at another time.': 'Você pode atribuir os usuários em outro momento.',
  MAIN_CURRENCY_FIELD_INFO_TEXT: 'Permite selecionar uma moeda de referência, para exibir os valores expressos em uma única moeda.',
  'Status (only Payment Institution)': 'Status (apenas instituição de pagamento)',
  Reset: 'Limpar',
  'Rate edited successfully!': 'Taxa editada com sucesso!',
  'Rate restarted successfully!': 'Taxa reiniciada com sucesso!',
  Currencies: 'Moedas',
  'Activation email sent successfully': 'Email de ativação enviado com sucesso!',
  'Show inactive accounts': 'Mostre contas inativas',
  'Not connected': 'Não conectado',
  "We couldn't process this Link.": 'Não foi possível processar o link.',
  status: 'Status',
  country: 'País',
  'Last day': 'Saldo do último dia',
  'Beginning of day': 'Saldo de início do dia',

  Mode: 'Modo',
  mode: 'Modo',
  AUTOMATIC: 'Automática',
  MANUAL: 'Manual',
  MANUAL_DEPOSIT: 'Vencimento CDBs',
  MANUAL_COMMITTED: 'Vencimento Compromissadas',
  'Secondary Point of contact': 'Ponto de contato secundário',
  'Group by': 'Agrupar por',
  'Group by Owner': 'Agrupar por proprietário',
  'Search and filter by Currency, Owner, Institution': 'Pesquisar e filtrar por Moeda, Proprietário, Instituição',
  Number: 'Número',
  Branch: 'Agência',

  'Transaction data': 'Dados de transação',
  'Application data': 'Dados de aplicação',
  'Institution detail': 'Institution detail',
  'Copy detail': 'Copiar detalhes',
  'Information not valid as receipt': 'Esta informação não possui validade fiscal e nem como comprovante da transação',
  'Transaction detail': 'Detalhes da transação',
  'INSTITUTION DETAIL': 'Detalhes da instituição',
  'TRANSACTION DATA': 'Dados de transação',
  'ACCOUNT DETAIL': 'Detalhes da conta',
  'INVESTMENT DETAIL': 'Detalhes de investimento',
  'ADDITIONAL INFORMATION': 'Informação adicional',

  'Links created': 'Links criados',
  'Workspace successfully created!': 'Espaço de trabalho criado com sucesso!',
  'Workspace successfully saved!': 'Espaço de trabalho salvo com sucesso!',
  'Workspace successfully deleted!': 'Espaço de trabalho excluído com sucesso!',
  'View Workspace': 'Ver espaço de trabalho',
  'Create a Workspace': 'Crie um espaço de trabalho',
  'Edit Workspace': 'Editar espaço de trabalho',
  'Are you sure you want to delete this Workspace?': 'Tem certeza de que deseja excluir este espaço de trabalho?',
  'Pending Device Registration': 'Registro de dispositivo pendente',
  'An admin/master user must approve the registration of the device': 'Um usuário administrador/mestre deve aprovar o registro do dispositivo',
  'Device registration': 'Registro do dispositivo',

  'Almost there!': 'Quase lá!',
  'This institution requieres an Admin user to approve this registration in order to start processing information.': 'Esta instituição exige que um usuário administrador aprove este registro para iniciar as informações de processamento.',

  None: 'Nenhum',
  'Some links need to be updated manually. Please update them.': 'Alguns links precisam ser atualizados manualmente. Por favor, atualize-os.',
  'Some accounts are not updated. Please update them.': 'Algumas contas não foram atualizadas hoje. Por favor, atualize-as.',
  UP_TO_DATE_YES: 'Sim',
  UP_TO_DATE_NO: 'Não',
  'Updated on the day': 'Atualizada hoje',
  upToDate: 'Atualizada hoje',
  'View accounts': 'Visualize contas',
  'The information is being processed. {{linksCount}} links have been sent for processing.': 'A informação está sendo processada. {{linksCount}} links foram enviados para processamento.',
  'The information is being processed.': 'A informação está sendo processada.',
  'in process': 'em processo',
  Fee: 'Taxa',
  FEE: 'Taxa',
  'Service Cost': 'Custo do serviço',
  Taxes: 'Impostos',
  Tax: 'Imposto',
  'Sale Method': 'Método de venda',
  Voucher: 'Voucher',
  'Masked Card': 'Cartão',
  'Check Serial Number': 'Número de série',
  'Check Number': 'Número do cheque',
  'Are you sure you want to disable the account?': 'Tem certeza de que deseja desativar a conta?',
  'Create a dedicated space to share specific financial information with users within a workspace.': 'Crie um espaço dedicado para compartilhar informações financeiras específicas com usuários em um workspace.',

  'administrates the subscription and all the workspaces.': 'Gerencia a inscrição e todos os workspaces.',
  'has all the permissions to administrate a workspace.': 'Tem todas as permissões para gerenciar um workspace.',
  'has access to financial information. Can add and refresh links.': 'Tem acesso a informação financeira. Pode adicionar e atualizar links.',
  'has access only to the technical modules.': 'Tem acesso aos módulos técnicos.',
  "similar to the Finance role, but can't add/refresh links.": 'Semelhante à função Finanças, mas não pode adicionar/atualizar links.',

  'Share specific financial information with other users within a workspace.': 'Compartilhe informações específicas com outros usuários no workspace.',
  'What would you like to name your Workspace?': 'Como você gostaria de chamar seu workspace?',
  'Every customer starts with one workspace. You can create more depending on the financial information you need to share with specific users based on their role within your company.': 'Cada cliente começa com um espaço de trabalho. Você pode criar mais com base nas informações financeiras que precisa compartilhar com outros usuários da empresa.',
  'General Admin': 'Administrator Geral',
  Workspaces: 'Espaços de trabalho',
  Workspace: 'Espaço de trabalho',

  "{{company}}'s workspaces": 'Espaços de trabalho da {{company}}',
  "{{company}}'s views": 'Visualizações da {{company}}',
  'Check out the workspaces already available.': 'Confira os espaços de trabalho já disponíveis.',
  Identity: 'Identidade',
  Activate: 'Ativar',
  Security: 'Segurança',
  'User Activation': 'Ativação do usuário',
  'Please login to activate the workspace.': 'Faça login para ativar o espaço de trabalho.',
  'Back to login page': 'Voltar para a página de login',
  'Workspace successfully activated!': 'Espaço de trabalho ativado com sucesso!',
  'Workspace is being activated': 'O espaço de trabalho está sendo ativado',
  Copy: 'Copiar',
  'Link info': 'Informações do link',
  'Account info': 'Informação da conta',
  'N° account': 'N° de conta',
  PERIOD_ONE_TIME: 'Não se repete',
  PERIOD_MONTHLY: 'Todo mês, no dia {{day}}',
  PERIOD_WEEKLY: 'Toda semana às {{day}}',
  PERIOD_WEEKDAY: 'Segunda a Sexta-feira',
  PERIOD_MONDAY_TO_SATURDAY: 'Segunda a Sábado',
  PERIOD_EVERYDAY: 'Todos os dias',
  PERIOD_WEEKEND: 'Fim de semana',
  PERIOD_START_OF_MONTH: 'Início do Mês',
  'Sync Mode': 'Modo de sincronização',
  'Sync Type': 'Tipo de sincronização',
  'Information to sync': 'Informações para sincronizar',
  'Sync period': 'Período de sincronização',
  SYNC_MODES_ACCOUNT: 'Saldos das contas',
  SYNC_MODES_TRANSACTION: 'Transações',
  SYNC_MODES_INVESTMENT: 'Investimentos',
  SYNC_MODES_PAYMENT: 'Pagamentos',
  SYNC_MODES_INVESTMENT_MOVEMENT: 'Movimentos dos investimentos',
  SYNC_MODES_PAYMENT_RECEIPT: 'Comprovantes',
  SYNC_MODES_PIX_TRANSACTION: 'Pix',
  SYNC_MODES_PERIOD_STATEMENT: 'Extrato por período',
  SYNC_MODES_MONTHLY: 'Mensal',
  SYNC_MODES_ALL: 'Todas',
  'View schedules': 'Detalhes da atualizações',
  'Schedule refresh': 'Agendar atualizações',
  'Are you sure you want to delete this schedule?': 'Tem certeza que gostaria de remover esta atualização?',
  'Schedule successfully saved!': 'Atualização salva com sucesso!',
  'Schedule created successfully!': 'Atualização criada com sucesso!',
  'Start refresh at': 'Começa em',
  Time: 'Hora',
  Recurrence: 'Repetição',
  'My workspaces': 'Meus espaços de trabalho',
  "{{workspaceName}}'s users": 'Usuários de {{workspaceName}}',
  'Pending confirmation': 'Confirmação pendente',
  'Pending invitation': 'Convite pendente',
  'Successfully unsubscribed!': 'Cancelado com Sucesso!',
  'Are you sure you want to unsubscribe this Workspace?': 'Tem certeza de que deseja cancelar a inscrição neste espaço de trabalho?',
  Invitation: 'Convite',
  Accept: 'Aceitar',
  Decline: 'Rejeitar',
  Unsubscribe: 'Cancelar subscrição',
  Percentage: 'Percentagem',
  'Copy information': 'Copiar informações',

  'Workspace successfully abandoned!': 'Espaço de trabalho abandonado com sucesso!',
  'View successfully abandoned!': 'Visualização abandonada com sucesso!',
  'Are you sure you want to abandon this Workspace?': 'Tem certeza de que deseja abandonar este espaço de trabalho?',
  Abandon: 'Abandono',
  'Account category': 'Categoria de conta',
  SAVING: 'Conta Poupança',
  CHECKING: 'Conta Corrente',
  ESCROW: 'Conta de caução',
  INVESTMENT: 'Investimento',
  INVESTMENTS: 'Investimentos',
  FOOD: 'Food account',
  AUTOMATIC_APP: 'Aplicação Automática',
  CAPITAL_ACCOUNT: 'Conta Capital',
  'New schedule': 'Nova atualização',
  'Welcome {{firstName}}!': 'Bem-vindo {{firstName}}!',
  'Let’s get you started with Datanomik. Please take a look at the following steps.': 'Comece a trabalhar com a Datanomik. Por favor, siga os passos abaixo.',
  'Manage workspaces': 'Gerenciar workspaces',
  'Manage views': 'Gerenciar visualizações',
  'Workspace has been created! Through the settings menu, you can add more workspaces and share them with other users later.': 'O Workspace foi criado! Através do menu Configurações, você pode adicionar mais espaços de trabalho e compartilhá -los com outros usuários posteriormente.',
  'Invite new users to this workspace. They will have access to the modules according to the assigned role.': 'Convide novos usuários para este workspace. Eles terão acesso aos módulos que correspondem à função atribuída.',
  'Link your institutions. Normally in 3 single steps you can start visualizing financial information.': 'Vincular suas instituições. Normalmente, em apenas 3 passos, você pode começar a visualizar informações financeiras.',
  'Create a Link': 'Criar link',
  CREATE_LINK_INFO: '<strong>Importante:</strong> as informações estarão disponíveis no workspace onde o link foi criado.',
  'Connect APIs': 'Conecte as APIs',
  Invite: 'Convidar',
  'Add developers to integrate our APIs.': 'Convide desenvolvedores para integrar nossas APIs',
  'Forget lengthy and costly integrations.': 'Esqueça integrações longas e caras.',
  Skip: 'Pular',
  'Thanks for choosing Datanomik’s Business Gate to manage your finances in one place.': 'Obrigado por escolher Business Gate da Datanomik para gerenciar suas finanças em um só lugar.',
  'Set up your accounts & gain access to a full financial overview.': 'Configure suas contas e tenha acesso a uma visão financeira completa.',
  'Speed up decision making by visualizing all balances in one place.': 'Acelere a tomada de decisões visualizando todos os saldos em um só lugar.',
  'Analyze transactional data and improve reconciliation processes.': 'Analise dados transacionais e melhore os processos de reconciliação.',
  'Invite other users to join Business Gate. Share workspaces and their specific financial information.': 'Convide outros usuários para ingressar no Business Gate. Compartilhe o workspace e informações financeiras específicas.',
  'Link your institutions to the platform and start using Business Gate.': 'Vincule suas instituições à plataforma e comece a usar o Business Gate.',
  'Connect your institutions to the platform and take advantage of Business Gate.': 'Conecte suas instituições à plataforma e aproveite o Business Gate.',
  'Will you be the one to connect all of your institutions? If this is not the case, don\'t worry; you may skip this step and invite new users later.': 'Você será o único a conectar todas as suas instituições? Se não for esse o caso, não se preocupe; Você pode pular esta etapa e convidar novos usuários mais tarde.',
  Start: 'Começar',
  'Default Workspace successfully saved!': 'Espaço de trabalho padrão salvo com sucesso!',
  'Edit credential': 'Editar credencial',
  'You have some negative balances': 'Você tem alguns saldos negativos',
  'It seems there are no links created in this workspace.': 'Parece que não há links criados neste workspace.',
  'Start linking institutions in 3 singles steps: select country, select institution, and login. That’s it!': 'Comece a conectar instituições em 3 passos simples: selecione o país, selecione a instituição e faça o login. E pronto!',
  '*Every user in this workspace will be able to access information of the links you create.': '*Todos os usuários deste workspace poderão acessar as informações dos links que você criar.',
  'Please contact your workspace admin for more information.': 'Entre em contato com o administrador para obter mais informações.',
  Document: 'Documento',
  'Document Type': 'Tipo de Documento',
  'Check last updates': 'Verifique as últimas atualizações',
  'Active clients': 'Empresas ativas',
  'Select Client': 'Selecione Empresa',
  'Change Client': 'Mudar o cliente',
  'Swift code': 'Código Swift',
  'Net Value': 'Saldo Líquido',
  'Gross Value': 'Saldo Bruto',
  'Gross value': 'Saldo bruto',
  'Type of investment': 'Tipo de investimento',
  netBalanceLte: 'Saldo Líquido <=',
  netBalanceGte: 'Saldo Líquido >=',
  grossBalanceGte: 'Saldo Bruto >=',
  grossBalanceLte: 'Saldo Bruto <=',
  STOCKS: 'Stocks',
  BOND: 'Títulos',
  FUND: 'Fundo',
  DEPOSIT: 'Renda fixa',
  'DEPOSIT,COMMITTED': 'Renda fixa',
  COE: 'COE',
  Coe: 'COE',
  COMMITTED: 'Compromissada',
  'Show investments': 'Mostrar investimentos',
  'Hide investments': 'Ocultar investimentos',
  'Last day position': 'Posição do último dia',
  'Beginning of day position': 'Início da posição do dia',
  'Current position': 'Posição atual',
  Current: 'Atual',
  Position: 'Posição',
  Applications: 'Aplicações',
  Operation: 'Operação',
  Instrument: 'Instrumento',
  instrumentType: 'Instrumento',
  Expiration: 'Data vencimento',
  dueDate: 'Data vencimento',
  'Application expired': 'Expira hoje',
  'Applied value': 'Saldo aplicado',
  Return: 'Remuneração',
  'Current value': 'Saldo atual',
  'Profit ($)': 'Rentabilidade ($)',
  Profit: 'Rentabilidade',
  'Gross Profit': 'Rentabilidade Bruta',
  'Net Profit': 'Rentabilidade Líquida',
  'Date application': 'Data aplicação',
  'Application date': 'Data Aplicação',
  'Applications detail': 'Detalhe aplicações',
  'Available position': 'Posição disponível',
  Investments: 'Investimentos',
  Installments: 'Parcelas',
  'Cash Position': 'Posição de caixa',
  'Forecasted Cash Position': 'Posição de caixa projetada',
  'Position in {{currency}}': 'Posição em {{currency}}',
  'The maximum size is 64 characters': 'O tamanho máximo é de 64 caracteres',
  'The maximum size is 128 characters': 'O tamanho máximo é de 128 caracteres',
  USER: 'Usuário',
  'General Administrators': 'Administradores Gerais',
  'Add new General Admin': 'Adicionar novo administrador geral',
  'New General Admin': 'Novo Administrador Geral',
  'Please select a registered User in order to assign this category': 'Selecione um usuário registrado para atribuir esta categoria',
  'General admin successfully saved!': 'Administrador geral salvo com sucesso!',
  'General admin successfully removed!': 'Administrador geral removido com sucesso!',
  'Remove category': 'Remova a categoria',
  'Are you sure you want to remove him/her as General Administrator?': 'Tem certeza de que deseja removê -lo como administrador geral?',
  Reports: 'Relatórios',
  Report: 'Relatório',
  'Transactions Report': 'Reporte de Transações',
  'You do not have assigned workspaces': 'Você não tem workspaces atribuídos',
  '{{from}}-{{to}} of {{count}} records': '{{from}}-{{to}} de {{count}} registros',
  'Something went wrong!': '¡Algo deu errado!',
  'Customize your own reports!': 'Personalize seus próprios relatórios!',
  'Select one of the following options and create your financial reports': 'Selecione uma das seguintes opções e crie seus relatórios financeiros',
  'Create a Report': 'Crie um relatório',
  'Generate Report': 'Gerar Relatório',
  'New report': 'Novo relatório',
  'label.consolidatedPositionByDay': 'Posição consolidada por dia',
  'Consolidated balances per account groups by date.': 'Posição consolidada por grupos de contas por data.',
  'Contains information of your accounts and balances': 'Contém informações de suas contas e saldos',
  'Contains information of all the debits and credits in your accounts': 'Contém informações de todos os débitos e créditos em suas contas',
  Permissions: 'Permissões',
  'Workspace Permissions: {{workspace}}': 'Controle de acesso: {{workspace}}',
  Group: 'Grupo',
  'Create group': 'Criar grupo',
  'Save group': 'Salvar grupo',
  'New Group': 'Novo Grupo',
  'New permission': 'Novo',
  'Permission group successfully saved!': 'Grupo de permissão salvo com sucesso!',
  'Permission group successfully updated!': 'Grupo de permissão atualizada com sucesso!',
  'Are you sure you want to remove this permission group?': 'Tem certeza de que deseja remover este grupo de permissão?',
  'Permission group successfully deleted!': 'Grupo de permissão excluído com sucesso!',
  'Group Name': 'Nome do grupo',
  'In order to limit user access to links inside a workspace, define groups of permissions.': 'Para limitar o acesso do usuário a links dentro de um espaço de trabalho, defina grupos de permissões.',
  'Create a group name, choose the links you want to conceal or reveal.': 'Crie o nome do grupo, escolha os links que deseja ocultar ou revelar.',
  Access: 'Acesso',
  'No access': 'Sem acesso',
  Show: 'Mostrar',
  Hide: 'Disfarce',
  'Select option': 'Selecione a opção',
  'List of links': 'Lista de links',
  'List of users': 'Lista de usuários',
  'Search user': 'Usuário de pesquisa',
  GROUP_COMPANY: 'Companhia',
  GROUP_WORKSPACE: 'Espaço de trabalho',
  '({{count}}) Options': '({{count}}) no total',
  'Total Investments': 'Total investimentos',
  TOTAL_INVESTMENTS_INFO_TEXT: 'Esta seção apresenta a soma dos valores líquidos de todos os investimentos em cada moeda. Veja as atualizações mais recentes.',
  'Investments / Institution': 'Investimentos / Banco',
  'Investments / Owner Tag': 'Investimentos / Tag do proprietário',
  'Investments / Account Tag': 'Investimentos / Tag da conta',
  'Investments / Account group': 'Investimentos / Grupo da conta',
  'Investments / Owner': 'Investimentos / Proprietário',
  INVESTMENTS_INSTITUTION_INFO_TEXT: 'Este gráfico apresenta como seus saldos de investimento são distribuídos em cada moeda por instituição.',
  INVESTMENTS_GENERAL_OWNER_TAG_INFO_TEXT: 'Este gráfico apresenta como seus saldos de investimento são distribuídos em cada moeda por tag do propietário.',
  INVESTMENTS_ACCOUNT_TAG_INFO_TEXT: 'Este gráfico apresenta como seus saldos de investimento são distribuídos em cada moeda por tag da conta.',
  INVESTMENTS_ACCOUNT_GROUP_INFO_TEXT: 'Este gráfico apresenta como seus saldos de investimento são distribuídos em cada moeda por grupo da conta.',
  'Investments / type': 'Investimentos / tipo',
  INVESTMENTS_TYPE_INFO_TEXT: 'Este gráfico apresenta como seus investimentos em cada moeda são distribuídos por tipo.',
  'Investments evolution': 'Evolução dos investimentos',
  INVESTMENTS_EVOLUTION_INFO_TEXT: 'Este gráfico apresenta como os investimentos (valores líquidos) evoluem ao longo do tempo. Você pode aplicar filtros.',
  'Authorized IPs': 'IPs autorizados',
  'Add new IP': 'Adicionar novo IP',
  'Are you sure you want to remove this IP Address?': 'Tem certeza de que deseja remover este endereço IP?',
  'IP Address successfully deleted!': 'Endereço IP excluído com sucesso!',
  'Add new IP address': 'Adicionar novo endereço IP',
  'Add IP address': 'Criar endereço IP',
  'IP Address successfully created!': 'Endereço IP criado com sucesso!',
  'Edit IP address': 'Editar endereço IP',
  'Save IP address': 'Salvar endereço IP',
  'IP Address successfully saved!': 'Endereço IP salvo com sucesso!',
  'Contains information on the position of each investment': 'Contém informações sobre a posição de cada investimento',
  'Financial Position': 'Posição Financeira',
  'Contains information of your accounts, balances and investments all together': 'Contém informações de suas contas, saldos e investimentos, todos juntos',
  'Historical balances': 'Saldos históricos',
  'Balance Evolution': 'Evolução dos saldos',
  'Contains information of historical balances of all the accounts': 'Contém informações de saldos históricos de todas as contas',
  'Partially registered': 'Parcialmente registrado',
  Partially: 'Parcialmente',
  'Go to report': 'Ir ao relatório',
  'Net Position / Institution': 'Fluxo de caixa / instituição',
  'Total Financial Position': 'Posição financeira total',
  'Financial Position / Institution': 'Posição financeira / Instituição',
  'Financial Position / Owner': 'Posição financeira / Proprietário',
  'Financial Position / Country': 'Posição financeira / País',
  'Financial Position / Account Tag': 'Posição financeira / Tag da conta',
  'Financial Position / Account group': 'Posição financeira / Grupo da conta',
  'Financial Position / Owner Tag': 'Posição financeira / Tag do proprietário',
  'Financial Evolution': 'Evolução financeira',
  'Financial Position / type': 'Composição de posição',
  'Debits / Category': 'Débitos por Categoría',
  GENERAL_TOTAL_INFO_TEXT: 'Esta seção apresenta a soma dos valores líquidos de todos os investimentos e saldos correntes da conta em cada moeda. Confira as últimas atualizações.',
  GENERAL_INSTITUTION_INFO_TEXT: 'Este gráfico apresenta como a posição financeira em cada moeda é distribuída por instituição.',
  GENERAL_COUNTRY_INFO_TEXT: 'Este gráfico apresenta como a posição financeira em cada moeda é distribuída por país.',
  GENERAL_GENERAL_OWNER_TAG_INFO_TEXT: 'Este gráfico apresenta como a posição financeira em cada moeda é distribuída por tag do proprietário.',
  GENERAL_ACCOUNT_TAG_INFO_TEXT: 'Este gráfico apresenta como a posição financeira em cada moeda é distribuída por tag da conta.',
  GENERAL_ACCOUNT_GROUP_INFO_TEXT: 'Este gráfico apresenta como a posição financeira em cada moeda é distribuída por grupo da conta.',
  GENERAL_CREDITS_DEBITS_AND_BALANCE_EVOLUTION_INFO_TEXT: 'Este gráfico apresenta como a posição financeira evolui com o tempo. Pode aplicar filtros.',
  GENERAL_TYPE_INFO_TEXT: 'Este gráfico apresenta como a posição financeira em cada moeda é distribuída por liquidez e tipo de investimento.',
  GENERAL_NET_POSITION_PER_INSTITUTION_INFO_TEXT: 'Este gráfico apresenta a soma dos créditos e débitos por instituição e a posição líquida. Não inclui investimentos. Pode aplicar filtros.',
  'Total Position': 'Posição total',
  '≈ Total Position': '≈ Posição total',
  'Account Balance': 'Saldos de contas',
  'Account balance': 'Saldos de conta',
  'is between': 'está entre',
  contains: 'contém',
  'Value net of taxes and fees, available to rescue.': 'Saldo líquido de impostos e taxas, disponível para resgate.',
  'Blocked balance': 'Saldo bloqueado',
  'Judicial blocked balance': 'Saldo bloqueio judicial',
  'Overdraft Limit Check': 'Limite cheque empresa',
  'Overdraft Limit': 'Sobregiro',
  'Taxes Provision': 'Provisão de impostos',
  'Add new General Owner': 'Adicionar novo Grupo de Proprietários',
  'Edit General Owner': 'Editar Grupo de Proprietários',
  'Add General Owner': 'Adicionar proprietário',
  'Save General Owner': 'Salvar proprietário',
  'General Owner successfully created!': 'Proprietário criado com sucesso!',
  'General Owner successfully saved!': 'Proprietário salvo com sucesso!',
  'General Owner successfully deleted!': 'Proprietário excluído com sucesso!',
  'Are you sure you want to remove this General Owner?': 'Tem certeza de que deseja remover este Grupo de Proprietários?',
  Reassign: 'Reasignar',
  'Reassign General Owner': 'Reasignar o proprietário',
  'General Owner': 'Grupo de Proprietário',
  'General Owners': 'Grupos de Proprietários',
  'Sync General Owners': 'Sincronize os proprietários',
  'Sync General Owners successfully!': 'Proprietários sincronizados com sucesso!',
  'Links Sync Schedule': 'Programação de sincronização de links',
  'Reassign Owner successfully saved!': 'O proprietário de reatribuição salvo com sucesso!',
  Updating: 'Atualizando',
  'Execution name': 'Nome da execução',
  'Bank Statements': 'Extrato bancário',
  Format: 'Formato',
  'Request Statement': 'Solicitação de extrato',
  'Bank statement request': 'Solicitação de extrato bancário',
  'Request for bank statements received. Check status in downloads menu.': 'Recebido o pedido do extrato bancário. Veja o status do pedido no menu download.',
  'Check Downloads': 'Veja descargas',
  'Request another statement': 'Solicitar outro extrato',
  'Request Date': 'Data do Pedido',
  requestDate: 'Data do Pedido',
  'No results': 'Sem resultados',
  NO_ROWS: 'Sem resultados',
  Download: 'Baixar',
  Downloads: 'Baixar',
  'New Report': 'Geração',
  'Download as ZIP': 'Baixe ZIP',
  'Download successfully': 'Baixar com sucesso',
  'You need to reassign owners before the list shows any entries.': 'É necessário reatribuir proprietários antes da lista exibir qualquer entrada.',
  Completed: 'Concluída',
  COMPLETED: 'Concluída',
  'Sync Status': 'Status da Atualização',
  'Account Status': 'Status da Conta',
  'Balances Status': 'Status dos Saldos',
  'Transactions Status': 'Status das Transações',
  'Investments Status': 'Status dos Investimentos',
  syncStatus: 'Status da Atualização',
  accountSyncStatus: 'Status dos Saldos',
  trxSyncStatus: 'Status das Transações',
  investmentSyncStatus: 'Status dos Investimentos',
  paymentSyncStatus: 'Status dos Pagamentos',
  invMovementSyncStatus: 'Status dos Movimentos dos Investimentos',
  paymentReceiptSyncStatus: 'Status do Comprovante',
  paymentSlipSyncStatus: 'Status das Francesinhas',
  pixTransactionSyncStatus: 'Status do Pix',
  'Payments Status': 'Status dos Pagamentos',
  Fail: 'Fracassada',
  FAILED: 'Fracassada',
  'Link sync Fail': 'Não atualizado',
  'Includes the available balance in checking account and the invested money net of taxes and fees.': 'Inclui o saldo disponível da conta corrente e o valor investido líquido de impostos e taxas.',
  'New Dashboard': 'Novo dashboard',
  Dashboards: 'Dashboards',
  'Two Factor Authentication': 'Autenticação de dois fatores',
  'Is an additional security level to prevent others from accessing private information. When logging in, you may be asked to input a 6-digit token.': 'É um nível de segurança adicional para evitar que outras pessoas acessem informações privadas. Ao fazer login, você pode ser solicitado a inserir um token de 6 dígitos.',
  'The next time you log in, you will be prompted to enable Google Authenticator. Occasionally you may be required to provide a 6-digit token.': 'Na próxima vez que fizer login, você será solicitado a ativar o Google Authenticator. Ocasionalmente, você poderá ser solicitado a fornecer um token de 6 dígitos.',
  'Are you sure you want to disable Two Factor Authentication?': 'Tem certeza de que deseja desativar a autenticação de dois fatores?',
  Confirm: 'Confirme',
  'Reset Token': 'Redefinir o Token',
  'Token reset successfully!': 'Redefinição de token com sucesso!',
  'Are you sure you want to reset {{userName}}’s Token?': 'Tem certeza de que deseja redefinir o Token de {{userName}}?',
  'Set up Google Authenticator': 'Configurar o Google Authenticator',
  'Please install the Google Authenticator app on your device, and then scan the QR code below to set up two-factor authentication (2FA) for the first time.': 'Por favor, instale o aplicativo Google Authenticator em seu dispositivo e, em seguida, escaneie o código QR abaixo para configurar a autenticação de dois fatores (2FA).',
  'Please insert here the token generated (6 digits).': 'Por favor, insira aqui o token gerado (6 dígitos).',
  'Two-factor authentication (2FA)': 'Autenticação de dois fatores (2FA)',
  'Assign Permissions': 'Atribuir permissões',
  'Tag account': 'Tag uma conta',
  'Tag successfully deleted!': 'Tag excluído com sucesso!',
  'Add Tag': 'Adicionar tag',
  'View Tag': 'Visualize a tag',
  'Tag successfully created!': 'Tag criado com sucesso!',
  'Tag successfully saved!': 'Tag salva com sucesso!',
  'Edit Tag': 'Editar tag',
  'Add new Tag': 'Adicione nova tag',
  'Are you sure you want to remove this Tag?': 'Tem certeza de que deseja remover esta tag?',
  'Tag management': 'Gerenciamento de tags',
  Tag: 'Tag',
  Tags: 'Tags',
  accountTagId: 'Tag da conta',
  'New Account group': 'Novo grupo de contas',
  'Account group successfully created!': 'Grupo de conta criado com sucesso!',
  'Account group successfully saved!': 'Grupo de conta salvo com sucesso!',
  'Account group edited successfully!': 'Grupo de conta editado com sucesso!',
  'Account group successfully deleted!': 'Grupo de conta excluído com sucesso!',
  'Are you sure you want to remove this Account group?': 'Tem certeza de que deseja remover este grupo de conta?',
  'Account group management': 'Gerenciamento de grupo de contas',
  'Account group': 'Grupo de contas',
  'Account group list': 'Lista do grupo de contas',
  accountGroupId: 'Grupo de contas',
  'Resend mobile verification code': 'Encaminhar via celular',
  'Resend email verification code': 'Encaminhar via email',
  'Resend invitation': 'Encaminhar via SMS',
  'Resend mobile invitation successfully': 'Encaminhar via SMS',
  'Share (%)': 'Particip. (%)',
  'Transaction created successfully!': 'Transação criada com sucesso!',
  'Add record': 'Adicionar',
  'Data entry': 'Entrada de dados',
  generalOwnerTagId: 'Tag do proprietário',
  'Tag list': 'Lista de tags',
  'Tag owner': 'Tag proprietário',
  'New tag': 'Novo tag',
  'Owner tag': 'Tag do proprietário',
  'Account tag': 'Tag da conta',
  'All account tags': 'Todas',
  'Add manually': 'Adicionar manualmente',
  'Transaction deleted successfully!': 'Transação excluída com sucesso!',
  'Are you sure you want to delete this Transaction?': 'Tem certeza de que deseja excluir esta Transação?',
  'Transaction updated successfully!': 'Transação atualizada com sucesso!',
  'There are links with automatic refresh schedules; if necessary, add this new link to those rules.': 'Existem links com programações de atualização automática; se necessário, adicione este novo link a essas regras.',
  'Assign Ownership': 'Atribuir propriedade',
  Ownership: '% Propriedade',
  '% Ownership': '% Propriedade',
  'Assign Percentage': 'Atribuir porcentagem',
  'The percentage must be less than or equal to 100.': 'A porcentagem deve ser menor ou igual a 100.',
  'The percentage must be greater than or equal to 0.': 'A porcentagem deve ser maior ou igual a 0.',
  'The value must be greater than or equal to 0.': 'A valor deve ser maior ou igual a 0.',
  'The value must be less than or equal to {{availableBalance}}.': 'A valor deve ser menor ou igual a {{availableBalance}}.',
  'The value must be greater than 0.': 'A valor deve ser maior a 0.',
  'The value must be greater than {{availableBalance}}.': 'A valor deve ser maior a {{availableBalance}}.',
  'The value must be greater than or equal to {{availableBalance}}.': 'A valor deve ser maior ou igual a {{availableBalance}}.',
  'The difference must be greater than or equal to {{availableBalance}}.': 'A diferença deve ser maior ou igual a {{availableBalance}}.',
  'Request now': 'Solicitar agora',
  Schedules: 'Agendar',
  'New Bank statements schedule': 'Novo agendamento',
  'Starts at': 'Começa em',
  Repetition: 'Repetição',
  'N° Days': 'N° dias',
  'Quick access': 'Acesso rápido',
  Last: 'Últimos',
  'To schedule': 'Agendar solicitação',
  'When selecting a link, we will request the bank statements of all accounts associated with this link': 'Ao selecionar um link, solicitaremos os extratos bancários de todas as contas associadas a esse link',
  DAY_TYPE_DAYS: 'Últimos {{days}} dias',
  DAY_TYPE_THIS_MONTH: 'Este mês',
  DAY_TYPE_LAST_MONTH: 'Mês passado',
  SYNC_LAST_MONTH: 'Mês passado',
  SYNC_LAST_WEEK: 'Semana passada',
  SYNC_LAST_BUSINESS_DAY: 'Último dia útil',
  SYNC_NOW: 'Informação do dia',
  'Bank statements schedule successfully!': 'solicitação criada com sucesso!',
  'Bank statements schedule successfully saved!': 'Solicitação salva com sucesso!!',
  'Are you sure you want to remove this Bank statements schedule?': 'Você tem certeza de que deseja excluir esta Solicitação?',
  'Bank statements schedule successfully deleted!': 'Solicitação excluído com sucesso!',
  'Report created successfully!': 'Relatório criado com sucesso!',
  'Report saved successfully!': 'Relatório salvo com sucesso!',
  'Save report': 'Salvar relatorio',
  'Report already exists': 'Relatório já existe',
  'Report deleted successfully!': 'Relatório excluído com sucesso!',
  'Are you sure you want to remove this Report?': 'Tem certeza de que deseja remover este relatório?',
  'Token was sent to': 'Token foi enviado para',
  'Token expires in 1 minute': 'Token expira em 1 minuto',
  'The maximum waiting time has elapsed, refresh the page or contact your administrator.': 'O tempo máximo de espera foi decorrido, atualize a página ou entre em contato com seu administrador.',
  'Minimum and maximum cash': 'Caixa mínimo e máximo',
  'Minimum and maximum cash target': 'Meta de Caixa mínimo e máximo',
  'Cash target': 'Meta de caixa',
  'Cash limits': 'Limites de caixa',
  Target: 'Meta',
  'Set minimum and maximum cash limits per currency to optimize the management of your account balances.': 'Defina limites mínimos e/ou máximos da caixa por moeda, para otimizar o gerenciamento dos saldos de suas contas.',
  'Set minimum and/or maximum cash limits for this specific account.': 'Defina limites mínimos e/ou máximos da caixa para essa conta específica.',
  'Minimum cash': 'Caixa minima',
  'Maximum cash': 'Caixa maxima',
  'Account balance limit deleted successfully!': 'Limite de caixa excluído com sucesso!',
  'Are you sure you want to delete this account balance limit?': 'Tem certeza de que deseja excluir esse limite de caixa?',
  'Account balance limit successfully saved!': 'Limite de caixa salvo com sucesso!',
  'Account balance limit successfully updated!': 'Limite de caixa atualizado com sucesso!',
  Surplus: 'Excedente',
  'To cover': 'A cobrir',
  'No rules created yet': 'Sem regras criadas ainda',
  'Add all new links to this scheduled refresh.': 'Adicionar todos os novos links a essa atualização programada.',
  'All new links will be added to this scheduled refresh.': 'Todos os novos links serão adicionados a essa atualização programada.',
  'Add "{{tagName}}"': 'Adicionar "{{tagName}}"',
  'Please verify the entered information.': 'Por favor, verifique os dados inseridos.',
  'Please verify the entered credentials.': 'Por favor, verifique as credenciais inseridas.',
  'It was not possible to connect with the Institution.': 'Não foi possível conectar-se com a Instituição.',
  'The user used does not have the required permissions.': 'O usuário utilizado não possui as permissões requeridas.',
  'You already have an open session in the Institution. Please close the session and try again.': 'Você já possui uma sessão aberta na Instituição. Por favor, encerre a sessão e tente novamente.',
  'Connection not possible. The user used has second-factor authentication.': 'Não é possível conectar. O Usuário contém o segundo fator habilitado.',
  Retry: 'Tentar novamente',
  'Please try again later': 'Por favor, tente novamente mais tarde',
  'Institution linked!': 'Instituição conectada!',
  'This institution requires an Master user to accept this registration within the home banking.': 'A instituição exige que um usuário Master aceite o cadastro na internet banking.',
  'We’re processing the information, this might take a while to reflect on the platform.': 'Estamos processando as informações, isso pode levar algum tempo para aparecer na plataforma. ',
  'Meanwhile, please set up the link refresh frequency.': 'Enquanto isso, por favor defina a frequência de atualização do link.',
  'There is already a link created with the same credentials.': 'Já existe um link criado com as mesmas credenciais.',
  'Trust this device for 30 days': 'Confiar neste dispositivo por 30 dias',
  'Device name': 'Nome do dispositivo',
  Forecast: 'Projetada',
  Executed: 'Realizado hoje',
  'Cash generated throughout the day.': 'Fluxo de caixa líquido gerado durante o dia.',
  Expected: 'Previsto para hoje',
  'Further transactions projected to take place throughout the rest of the day.': 'Transações previstas para o resto do dia.',
  'Forecasted Balance': 'Saldo projetado',
  'Add transactions': 'Adicione transações',
  'File name': 'Nome do arquivo',
  'Total registers': 'Total de registros',
  'Registers uploaded': 'Registros carregados',
  'Registers with errors': 'Registros com erros',
  'Upload file': 'Subir arquivo',
  'Select file': 'Selecione o arquivo',
  Upload: 'Carregar',
  'File upload try again': 'Houve um erro com o arquivo.<br />Verifique a extensão ou tamanho.<br /><4>Tente novamente</4>.',
  'File successfully upload!': 'Archivo subido correctamente!',
  'New file': 'Novo arquivo',
  'Download file template': 'Baixar modelo de exemplo',
  'Create a link refresh schedule.': 'Crie uma atualização programada de link.',
  'Existing Link Schedules': 'Atualizaçãos programada de link existentes',
  'This link was added to the {{name}} automatic refresh shedule.': 'O link foi adicionado à atualização programada: {{name}}.',
  'Initial position': 'Posição inicial',
  'End position of the day': 'Posição final',
  'Initial balance': 'Saldo inicial',
  'End balance of the day': 'Saldo final',
  'Cash flow': 'Fluxo de caixa',
  'label.cashflow': 'Fluxo de caixa',
  'label.dailyCashflow': 'Fluxo de caixa diário',
  'label.monthlyCashflow': 'Fluxo de caixa mensal',
  'Liquid flow': 'Fluxo líquido',
  Accomplished: 'Realizado',
  Projected: 'Projetado',
  INVESTMENT_BALANCE: 'Investimentos',
  INVESTMENT_BALANCE_END: 'Investimentos (posição)',
  ACCOUNT_BALANCE: 'Saldos da conta',
  OTHERS: 'Outros',
  'Category group successfully created!': 'Grupo de cateogoria crie com sucesso!',
  'Category group successfully saved!': 'Grupo de cateogoria salva com sucesso!',
  'Cashflow targets successfully saved!': 'Fluxo de caixa targets salva com sucesso!',
  'Cashflow Configuration': 'Configuração do Fluxo de caixa',
  Consolidated: 'Consolidado',
  Incompleted: 'Incompleto',
  'We couldn\'t sync this Link completely.': 'Não poderíamos sincronizar este link completamente.',
  'Link expires in {{time}} minutes': 'O link expira em {{time}} minutos',
  'Link expires in {{time}}': 'O link expira em {{time}}',
  'Favourite account successfully saved!': 'Conta favorita salva com sucesso!',
  Favourite: 'Favorito',
  'Open link': 'Abra o link',
  Daily: 'Diário',
  'Download errors': 'Baixar erros',
  'Automatic applications': 'Aplicaçoes automáticas',
  'Value From': 'Valor de',
  'Value To': 'Valor até',
  'label.applicationTemplate': 'Planilha Modelo Aplicação',
  'label.cvcApplicationTemplate': 'Planilha Modelo Aplicação e Resgate',
  'label.rescueTemplate': 'Planilha Modelo Resgate',
  'label.financialPosition': 'Posição Financeira',
  'label.financialPositionByOwner': 'Posição Financeira pelo Proprietário',
  'label.financialPositionCustom': 'Posição Financeira (personalizado)',
  'label.financialPositionExecutive': 'Posição Financeira Executiva',
  'label.accounts': 'Contas',
  'label.accountsCustom': 'Contas (personalizado)',
  'label.accountsGroupCustom': 'Posição Financeira - Grupo de contas',
  'label.accountsHistoryCustom': 'Contas - histórico (personalizado)',
  'label.customs': 'Customs',
  'label.historicalBalances': 'Saldos Históricos',
  'label.investments': 'Investimentos',
  'label.investmentsCustom': 'Investimentos (personalizado)',
  'label.investmentsHistoryCustom': 'Investimentos - histórico (personalizado)',
  'label.accountsForecastBalance': 'Evolução dos Saldos',
  'label.positionByBusiness': 'Posição por negócio',
  'label.investmentsHistory': 'Histórico de Investimentos',
  'label.investmentsMonthly': 'Investimentos Mensais',
  'label.investmentsEvolution': 'Evolução da Posição',
  'label.investmentMovements': 'Movimentos de Investimentos',
  'label.investmentsByMonth': 'Investimentos por mês',
  'label.depositMovement': 'Movimentos de CDBs',
  'label.fundMovement': 'Movimentos de Fundos',
  'label.committedMovement': 'Movimentos de Compromissadas',
  'label.automaticApplicationMovement': 'Movimentos da aplicações automáticas',
  'label.automaticApplicationMonthlyBalances': 'Saldo mensal da aplicações automáticas',
  'label.transactions': 'Transações',
  'label.transactionNotImpactCashflow': 'Transações que não impactam o fluxo de caixa',
  'label.transactionsPaymentsNotImpactCashflow': 'Pagamentos que não impactam o fluxo de caixa',
  'label.transactionsCategories': 'Transações com Categorias',
  'label.transactionsByAccount': 'Transações por Conta',
  'label.transactionsByAccountLastDay': 'Transações Por Dia de Fechamento da Conta',
  'label.transactionsManualByAccount': 'Transações Previstas por Conta',
  'label.transactionsDailyPaymentConference': 'Conferência de Pagamentos Diários',
  'label.transactionsPayments': 'Pagamentos',
  'label.transactionsCategoriesFees': 'Tarifas por Mês',
  'label.transactionsIntraCompany': 'Transferências entre contas de mesma titularidade',
  'label.transactionsFeesDaily': 'Taxas diárias',
  'label.weeklyPositionBalances': 'Posição de Saldos Semanal',
  'label.favourite': 'Favoritos',
  'label.cashFlowByCompany': 'Fluxo de caixa por empresa',
  'label.positionByCompany': 'Posição por empresa',
  'label.accountsConsolidatedOwner': 'Visão consolidada por Proprietário',
  'label.accountsBlockedBalanceEvolution': 'Saldos bloqueados históricos',
  'label.accountsBlockedJudicialBalanceEvolution': 'Saldos históricos bloqueados judiciais',
  'label.dailyBalanceOfApplicationsByInstitution': 'Saldo diário de aplicações por Instituição',
  'label.dailyApplicationBalancePerOwner': 'Saldo diário de aplicações por proprietário',
  'Historical evolution of blocked balances per account.': 'Evolução histórica dos saldos bloqueados por conta.',
  'Historical evolution of judicially blocked balances, by account.': 'Evolução histórica dos saldos bloqueados judicialmente, por conta.',
  'Surplus balances and balances to be covered, grouped by Owner': 'Saldos excedentes e a serem cobertos, agrupados por Proprietário',
  'Current cash position per account.': 'Posição de caixa do dia atual por conta.',
  'Current balances per account.': 'Saldos do dia atual por conta.',
  'Historical evolution of balances per account.': 'Evolução histórica dos saldos por conta.',
  'Historical evolution of checking account and investment balances.': 'Evolução histórica dos saldos por conta corrente e investimento.',
  'Consolidated balances and investments from the previous day, grouped by account and owner tags.': 'Saldos e investimentos consolidados do dia anterior, agrupados por tags de conta e proprietário.',
  'Cash flow by company.': 'Fluxo de caixa por empresa.',
  'Cash position projection for the day.': 'Projeção da posição de caixa do dia.',
  'Current investment position per account.': 'Posição atual investida por conta.',
  'Historical evolution of investments per account.': 'Evolução histórica dos investimentos por conta.',
  'Daily balance of applications (by Institution)': 'Saldo diário de aplicações (por Instituição)',
  'Daily balance of applications (by Owner)': 'Saldo diário de aplicações (por proprietário)',
  'Monthly position of each investment.': 'Posição mensal por investimento.',
  'Transaction details for a date range.': 'Detalhe das transações em um intervalo de datas.',
  'Transaction details with the categories included.': 'Detalhe das transações com as categorias incluídas.',
  'Applications and withdraws for a date range.': 'Aplicações e resgates em um intervalo de datas.',
  'Current invested position per application.': 'Posição atual investida por aplicação.',
  'Historical invested position per application.': 'Posição histórica investida por aplicação.',
  'Position by application, sorted by oldest application date and lowest remuneration.': 'Posição por aplicação, ordenadas por data de aplicação mais antiga e menor remuneração.',
  'The platform will connect with Open Finance': 'A plataforma se conectará com <strong>{{ name }}</strong> por meio de conexões Open Finance, para obter uma visão financeira completa.',
  'By pressing “Continue”, you confirm acceptance of the Terms and Conditions.': 'Ao continuar, você aceita os <2>Termos e Condições</2>.',
  'Iniciador is our partner for financial data connection and data sharing. Through Iniciador, you can securely provide us with your data, and you also have the possibility to control and revoke this access at any time.': 'O Iniciador é nosso parceiro de conexão e compartilhamento de dados financeiros. Através do Iniciador, você pode disponibilizar os seus dados de forma segura conosco, além de poder controlar e revogar esse acesso a qualquer momento.',
  'Iniciador is an institution authorized and regulated by the Central Bank of Brazil, a certified participant of Pix framework and Open Finance Brasil, registered under CNPJ 44.471.172/0001-19.': 'O Iniciador é uma instituição autorizada e regulada pelo Banco Central do Brasil, participante homologada do Arranjo Pix e do Open Finance Brasil, inscrito sob o CNPJ 44.471.172/0001-19.',
  'Check the terms and conditions.': 'Confira os termos e condições.',
  'Terms and conditions': 'Termos e condições',
  'Learn more about data and deadlines': 'Saiba mais sobre os dados e prazos',
  'Data and deadlines': 'Dados e prazos',
  'The data that will be shared by your Bank are:': 'Os dados que serão compartilhados do seu Banco são:',
  'Account data': 'Dados da conta',
  '1. Identification': 'Identificação',
  '1. Balances': 'Saldos',
  '2. Limits': 'Limites',
  '3. Transactions': 'Transações',
  'Registration data': 'Dados cadastrais',
  'Frequently asked questions': 'Perguntas frequentes',
  'How is the sharing done?': 'Como é feito o compartilhamento?',
  'Data sharing is carried out through Iniciador, an institution authorized by the Central Bank of Brazil to connect with other institutions via Open Finance:': 'O compartilhamento de dados é feito pelo Iniciador, uma instituição autorizada pelo Banco Central do Brasil para se conectar a outras instituições via Open Finance:',
  'Share your account data with Iniciador': 'Compartilhe os dados da sua conta com o Iniciador',
  'Through Open Finance, Iniciador collects the banking data you allow and prepares it for secure sharing with us.': 'Através do <strong>Open Finance</strong>, o Iniciador coleta os dados bancários que você permitir e os prepara para o compartilhamento desses dados de forma segura conosco.',
  'You authorize Iniciador to share with us the account data you are connecting': 'Você autoriza o Iniciador a compartilhar conosco os dados da conta que você vai conectar',
  'Iniciador acts as your intermediary, allowing only the sharing with us of the data you authorize, protected by the General Data Protection Law.': 'O Iniciador atua como seu mensageiro, apenas permitindo o compartilhamento conosco dos dados que você autorizar, amparado pela <strong>Lei Geral de Proteção de Dados</strong>.',
  'What is Open Finance?': 'O que é o Open Finance',
  'Open Finance is the evolution of Open Banking. It refers to the ability of customers of financial products and services to allow the sharing of their information among different institutions authorized by the Central Bank and the movement of their bank accounts from various platforms, not just through the bank\'s app or website, in a secure, efficient, and convenient manner.': 'É a evolução do Open Banking, ou sistema financeiro aberto, é a possibilidade de clientes de produtos e serviços financeiros permitirem o compartilhamento de suas informações entre diferentes instituições autorizadas pelo Banco Central e a movimentação de suas contas bancárias a partir de diferentes plataformas e não apenas pelo aplicativo ou site do banco, de forma segura, ágil e conveniente.',
  'Who is Iniciador?': 'Quem é o Iniciador?',
  'Iniciador is our partner for financial data connection and sharing. Through Iniciador, you can securely provide us with your data, and you also have the ability to control and revoke this access at any time.': 'O Iniciador é nosso parceiro de conexão e compartilhamento de dados financeiros. Através do Iniciador, você pode disponibilizar os seus dados de forma segura conosco, além de poder controlar e revogar esse acesso a qualquer momento.',
  'Iniciador is an institution authorized and regulated by the Central Bank of Brazil, an approved participant of the Pix Arrangement and Open Finance Brazil, registered under CNPJ 44.471.172/0001-19.': 'O Iniciador é uma instituição autorizada e regulada pelo Banco Central do Brasil, participante homologada do Arranjo Pix e do Open Finance Brasil, inscrito sob o CNPJ 44.471.172/0001-19.',
  'How can I manage my shared data?': 'Como posso gerenciar meus dados compartilhados?',
  'At any time, you can modify, renew, or cancel your data sharing through the Open Finance Management panel available in the main menu of this application or through the link: portal.iniciador.com.br.': 'A qualquer momento você poderá alterar, renovar ou cancelar seu compartilhamento de dados pelo painel de Gestão Open Finance disponível no menu principal deste aplicativo ou pelo link: <2>portal.iniciador.com.br</2>.',
  'Preparing the open finance connection': 'Preparando a conexão para open finance',
  'Summary of the sharing': 'Resumo do compartilhamento',
  'Redirecting to {{name}} in {{count}}': 'Redirecionando para {{name}} em {{count}}',
  'Open Finance Management': 'Gestão Open Finance',
  'It could contain both checking account balances and automatic applications.': 'Pode conter saldos de contas correntes e aplicações automáticas.',
  'Available Cash Position': 'Posição total',
  'Includes the Available Balance + Automatic Applications and Investments Net Value.': 'Inclui o Saldo disponível na conta + Aplicações automáticas e Investimentos Saldo Líquido.',
  'Add cash account': 'Adicione conta dinheiro',
  'Write to create one': 'Escreva para criar um',
  'Owner successfully created!': 'Proprietário criado com sucesso!',
  'Cash Holding account successfully created!': 'Conta em dinheiro criada com sucesso!',
  'Cash Holding account successfully saved!': 'Conta em dinheiro salva com sucesso!',
  CASH: 'Dinheiro',
  CASH_HOLDING: 'Conta dinheiro',
  'Cash Holding': 'Conta dinheiro',
  'The account has an overdraft limit of {{value}}': 'A conta tem limite de check especial de {{value}}',
  lbl_full_account_number_ag: 'Agência',
  Agency: 'Agência',
  lbl_full_account_number_conta: 'Conta',
  lbl_full_account_number_dv: 'DV',
  digitCount_one: '{{count}} dígito',
  digitCount_other: '{{count}} dígitos',
  maxDigitCount_one: 'Máx. {{count}} dígito',
  maxDigitCount_other: 'Máx. {{count}} dígitos',
  'Schedule successfully deleted!': 'Atualização excluído com sucesso!',
  'Schedule successfully created!': 'Atualização criada com sucesso!',
  'Withdrawal criteria': 'Critério de resgate',
  Configuration: 'Configuração',
  Parameters: 'Parâmetros',
  'Create a schedule': 'Crie uma atualização',
  'View schedule': 'Detalhes da atualização',
  'Edit schedule': 'Editar atualização',
  'Delete schedule': 'Excluir atualização',
  'Are you sure you want to delete this Report schedule?': 'Tem certeza de que deseja excluir esta atualização de relatório?',
  'User unlocked successfully!': 'Usuário desbloqueado com sucesso!',
  Unlock: 'Desbloquear',
  Lock: 'Bloquear',
  'Are you sure you want to delete the {{name}} workspace?': 'Tem certeza de que deseja excluir o espaço de trabalho {{name}}?',
  'Performing this action will delete all the links that belong to the workspace and all the information related.': 'Ao realizar esta ação, todos os links que pertencem ao espaço de trabalho serão excluídos, assim como todas as informações relacionadas.',
  'To confirm the deletion, type the name of the workspace into the field.': 'Para confirmar a exclusão, digite o nome do espaço de trabalho no campo.',
  'Export to PDF': 'Exportar PDF',
  'Overview config successfully saved!': 'Configuração bem sucedida!',
  'Configuration successfully saved!': 'Configuração bem sucedida!',
  'Overview Config': 'Configuração',
  'Idle balance': 'Saldo Ocioso',
  'Balance in accounts': 'Saldo Ocioso',
  'Balance in investments': 'Investimentos',
  'Total blocked balance': 'Total saldo bloqueado',
  'Accounts with surplus': 'Saldo excedente',
  'Accounts to cover': 'Saldo a cobrir',
  'Negative accounts': 'Saldo negativo',
  Deleted: 'Excluída',
  'This account was deleted by the institution.': 'Esta conta foi excluída pela instituição.',
  'Net investment': 'Investimento líquido',
  'This is an estimated value.': 'Isso é um valor calculado.',
  Weekly: 'Por semana',
  'You have a total of {{currency}} {{todayAmount}} in investments that expires today.': 'Você possui um total de {{currency}} {{todayAmount}} em investimentos que vencem hoje.',
  'You have a total of {{currency}} {{todayAmount}} in investments that expires today. You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.': 'Você possui um total de {{currency}} {{todayAmount}} em investimentos que vencem hoje. Você possui um total de {{currency}} {{tomorrowAmount}} em investimentos que vencem amanhã.',
  'You have a total of {{currency}} {{tomorrowAmount}} in investments that expires tomorrow.': 'Você possui um total de {{currency}} {{tomorrowAmount}} em investimentos que vencem amanhã.',
  'You have a total of {{currency}} {{amount}} in investments that expires on {{dueDate}}.': 'Você possui um total de {{currency}} {{amount}} em investimentos que vencem em {{dueDate}}.',
  'You have a total of {{currency}} {{amount}} in Deposits that expire today.': 'Você possui um total de {{currency}} {{amount}} em CDBs que vencem hoje.',
  'You have a total of {{currency}} {{amount}} in COE that expire today.': 'Você possui um total de {{currency}} {{amount}} em COE que vencem hoje.',
  'You have a total of {{currency}} {{amount}} in Committed investments that expire today.': 'Você possui um total de {{currency}} {{amount}} em Compromissadas que vencem hoje.',
  'See here': 'Veja aqui',
  'Future cash': 'Caixa futuro',
  'Investments expiration': 'Vencimento de Investimentos',
  'There are no investments expiring in the selected period.': 'Não há investimentos com vencimento no período selecionado.',
  'There are no future credits or debits reported for the selected period.': 'Não há créditos ou débitos futuros informados para o período selecionado.',
  GENERAL_FUTURE_CASH_INFO_TEXT: 'Este gráfico apresenta os créditos, débitos e vencimentos dos investimentos para hoje e os próximos 6 dias.',
  'Committed Applications': 'Aplicações compromissadas',
  Committed: 'Compromissadas',
  committed: 'Compromissadas',
  'Deposit Applications': 'Aplicações de CDBs',
  COMMITTED_APPLICATIONS: 'Resgate Compromissadas',
  committedWithdrawName: 'Vencimento Compromissadas',
  DEPOSIT_APPLICATIONS: 'Resgate CDBs',
  depositWithdrawName: 'Vencimento CDBs',
  Deposit: 'Renda fixa',
  'Fund Applications': 'Aplicações de fundos',
  Fund: 'Fundos',
  'Total applied': 'Total aplicado',
  Indexer: 'Desempenho relativo',
  PERFORMANCE: 'Investimentos (desempenho)',
  'Remaining main balance': 'Saldo principal restante',
  'Quota balance': 'Saldo de cotas',
  'Quota quantity': 'Quantidade de cotas',
  'Quota gross price value': 'Valor do preço bruto da cota',
  'Financial Efficiency': 'Eficiência financeira',
  GENERAL_EFFICIENCY_INFO_TEXT: 'Este gráfico apresenta a eficiência financeira da posição de caixa, tanto diariamente quanto mensalmente, calculando a média diária de cada mês.',
  Efficiency: 'Eficiência',
  'Efficiency (%)': 'Eficiência (%)',
  'Investments net value': 'Investimentos saldo líquido',
  'Quota gross pice value': 'Valor da cota',
  'label.accountingTransactions': 'Transações Contábeis',
  'Partial errors': 'Erros parciais',
  'We are experiencing some connection instability with {{description}}.': 'Estamos experimentando alguma instabilidade de conexão com <strong>{{description}}</strong>.',
  'Please check out the last update. We are sorry for the inconvenience.': 'Confira a <2>última atualização</2>. Lamentamos o inconveniente.',
  'label.investmentApplications': 'Aplicações',
  'label.investmentsAppDeposit': 'Renda fixa',
  'label.investmentsAppDepositCustom': 'Renda fixa (personalizado)',
  'label.investmentsAppCommitted': 'Compromissadas',
  'label.investmentsAppCommittedCustom': 'Compromissadas (personalizado)',
  'label.investmentsAppFund': 'Fundos',
  'label.depositApplicationHistory': 'Histórico de Aplicações de CDBs',
  'label.committedApplicationHistory': 'Histórico de Aplicações Compromissadas',
  'label.fundApplicationHistory': 'Histórico de Aplicações de Fundos',
  Help: 'Ajuda',
  'To omit': 'Omitir',
  Finish: 'Terminar',
  'Future Transactions': 'Transações Futuras',
  'To be able to forecast balances, we need you to upload information on future credits and debits. Options: manually, by file, and via APIs.': 'Para podermos projetar os saldos, precisamos que você carregue informações sobre créditos e débitos futuros. Opções: manualmente, por arquivo e por APIs.',
  'Categorize your historical and future movements, based on your internal classification.': 'Categorize seus movimentos históricos e futuros, com base na sua classificação interna.',
  Targets: 'Metas',
  'Double click and incorporate targets to automatically verify their fulfillment.': 'Faça duplo clique e incorpore metas para verificar automaticamente o cumprimento das mesmas.',
  'Once the targets are incorporated, click on “Save”.': 'Uma vez incorporadas as metas, clique em “Salvar”.',
  'Tax on Financial Operations (IOF) is a tax that focuses on the income of financial investments and occurs in the redemptions made within 30 days of the date of application. See detail.': 'Imposto sobre Operações Financeiras (IOF) é um tributo que incide sobre os rendimentos das aplicações financeiras e ocorre nos resgates efetuados em um período inferior a 30  dias da data da aplicação.<br/><br/><3>Ver detalhe</3>',
  'Income tax is a tax that focuses on the net income of financial investments decreasing over time. See detail.': 'Imposto de Renda é um tributo que incide sobre os rendimentos líquidos das aplicações financeiras diminuindo ao longo do tempo.<br/><br/><3>Ver detalhe</3>',
  'Projected balance in investments': 'Saldo projetado em investimentos',
  'Projected balance in current accounts': 'Saldo projetado em contas correntes',
  forecastDate: 'Data',
  'label.historicalAutomaticApplications': 'Aplicações Automaticas Históricas',
  'Are you sure you want to delete this classification?': 'Tem certeza de que deseja excluir este classificação?',
  'Close Panel': 'Fechar painel',
  'Open Panel': 'Abra o painel',
  indicatorType: 'Indicador',
  Indicator: 'Indicador',
  SHORTAGE: 'Contas com saldo abaixo do mínimo',
  OVERAGE: 'Contas com saldo excedente',
  NEGATIVE: 'Contas com saldo negativo',
  'label.accountsBalanceEvolution': 'Evolução do Saldo',
  'label.forcastedCashPosition': 'Posição de Caixa Projetada',
  'Active filters': 'Filtros ativos',
  'One-time Password': 'Senha única',
  'Disabled by the company': 'Desativado pela empresa',
  'Provide a one-time password using Google Authenticator or similar.': 'Forneça uma senha de uso único usando o Google Authenticator ou um serviço semelhante.',
  'One-time password enabled succefully!': 'Senha de uso único ativada com sucesso!',
  'One-time password disabled succefully!': 'Senha de uso único desativado com sucesso!',
  Optimize: 'Otimizar',
  Criteria: 'Critério',
  'Manage Criteria': 'Gerenciar critérios',
  'What are the withdrawal criteria?': 'Quais são os critérios de resgate?',
  'What is the amount you want to withdraw?': 'Quanto você precisa para resgatar?',
  'Amount to withdraw': 'Valor a resgatar',
  'Total amount to withdraw': 'Valor total a resgatar',
  'For which owners do you need to withdraw?': 'Para quais proprietários você precisa fazer o resgate?',
  'From which institutions do you need to withdraw?': 'De quais instituições você precisa resgatar?',
  'From which accounts do you need to withdraw?': 'De quais contas você precisa resgatar?',
  'Are you sure you want to remove this Criteria?': 'Tem certeza de que deseja eliminar esse critério?',
  'Criteria successfully deleted!': 'Critério excluído com sucesso!',
  'Criteria successfully created!': 'Critério criado com sucesso!',
  'Criteria successfully saved!': 'Critério salvo com sucesso!',
  New: 'Novo',
  'Lower tax amount': 'Valor de imposto mais baixo',
  'Less remuneration': 'Menor remuneração',
  'Lower profitability': 'Menor rentabilidade',
  'Lower tax rates': 'Menor aliquota de impostos',
  'Withdraw Finish': 'Filtrar',
  'Withdraw Reset': 'Limpar',
  'Closer to the expiration date': 'Mais próximo da data de vencimento',
  'There are no investments expiring within this date range.': 'Não há investimentos vencendo neste intervalo de datas.',
  'Applications about to expire': 'Calendário de vencimentos',
  '{{count}} Applications_one': '{{count}} Aplicação',
  '{{count}} Applications_other': '{{count}} Aplicações',
  'You don’t have investments about to expire.': 'Não possui investimentos próximos a vencer.',
  'Impact Cash flow': 'Considerar para o fluxo de caixa',
  'label.accountsWeeklyPosition': 'Posição semanal',
  'negative balances': 'saldo negativo em c/c',
  'balances to cover': 'saldo a cobrir em c/c ',
  'surplus in balances': 'saldo excedente em c/c',
  'Application type': 'Tipo de aplicação',
  'Sync accounts: {{totalAccountProcessed}}/{{total}}': 'Saldos: {{totalAccountProcessed}} de {{total}} contas',
  'Sync account transactions: {{totalTrxProcessed}}/{{total}}': 'Transações: {{totalTrxProcessed}} de {{total}} contas',
  'Sync account investments: {{totalInvestmentProcessed}}/{{total}}': 'Investimentos: {{totalInvestmentProcessed}} de {{total}} contas',
  'Sync account payments: {{totalPaymentProcessed}}/{{total}}': 'Pagamentos: {{totalPaymentProcessed}} de {{total}} contas',
  'Sync account investment movements: {{totalInvMovementProcessed}}/{{total}}': 'Movimentos: {{totalInvMovementProcessed}} de {{total}} contas',
  'Sync account pix: {{totalPixTransactionProcessed}}/{{total}}': 'Pix: {{totalPixTransactionProcessed}} de {{total}} contas',
  'Sync account payment receipts: {{totalPaymentReceiptProcessed}}/{{total}}': 'Comprovantes: {{totalPaymentReceiptProcessed}} de {{total}} contas',
  'Sync account payment slips: {{totalPaymentSlipProcessed}}/{{total}}': 'Francesinhas: {{totalPaymentSlipProcessed}} de {{total}} contas',
  'Schedule report': 'Agendar envio',
  Program: 'Programar',
  'Report schedules': 'Agendamentos',
  'View Report schedules': 'Ver Agendamentos',
  LAST_DAY: 'Dia anterior',
  LAST_WORKING_DAY: 'Último dia útil',
  'Working days': 'Dias úteis',
  'Working days applied': 'Dias úteis aplicado',
  CURRENT_DAY: 'Dia atual',
  LAST_WEEK: 'Últimos 7 dias',
  LAST_15_DAYS: 'Últimos 15 dias',
  LAST_30_DAYS: 'Últimos 30 dias',
  LAST_MONTH: 'Mês passado',
  CURRENT_MONTH: 'Mês atual',
  Month: 'Mês',
  INSTITUTION_STATUS_ONLINE: 'Conexão estável',
  INSTITUTION_STATUS_OFFLINE: 'Conexão instável',
  INSTITUTION_STATUS_UNSTABLE: 'Conexão instável',
  'Status of all Institutions': 'Status de todas as instituições',
  'Institutions status': 'Status das instituições',
  CASH_FORECASTING: 'Dinheiro projetado',
  'Batch payments': 'Pagamentos em lote',
  'Batch number': 'Numero de Lote',
  batch: 'Numero de Lote',
  PAYMENT_STATUS_NOT_EXECUTED: 'Não efetuado',
  PIX_STATUS_EXECUTED: 'Efetuado',
  PAYMENT_STATUS_EXECUTED: 'Efetuado',
  PAYMENT_STATUS_PARTIALLY_AUTHORIZED: 'Parcialmente autorizado',
  PAYMENT_STATUS_AUTHORIZED: 'Autorizado',
  PAYMENT_STATUS_PENDING_EXECUTION: 'Execução pendente',
  PAYMENT_STATUS_UNKNOWN: 'Desconhecida',
  PAYMENT_STATUS_SCHEDULED: 'Agendado',
  PAYMENT_STATUS_BLOCKED: 'Bloqueado',
  PAYMENT_STATUS_CANCELED: 'Cancelado',
  PAYMENT_STATUS_REFUNDED: 'Devolveu',
  PAYMENT_STATUS_REJECTED: 'Rejeitado',
  PAYMENT_STATUS_PENDING_AUTHORIZATION: 'Pendente autorização',
  DOWNLOADABLE_STATUS_PENDING: 'Pendente',
  DOWNLOADABLE_STATUS_REQUESTED: 'Requerido',
  DOWNLOADABLE_STATUS_IN_PROGRESS: 'Em andamento',
  DOWNLOADABLE_STATUS_FAILED: 'Fracassada',
  DOWNLOADABLE_STATUS_PROCESSED: 'Processado',
  downloadable: 'Recibo de pagamento',
  'The link to your report has expired.': 'O link do seu relatório foi expirado.',
  'Login to the platform to generate a new report.': 'Acesse a plataforma para gerar um novo relatório.',
  'Unsupported file': 'Arquivo não compatível',
  Custom: 'Personalizado',
  'Has report schedules': '{{count}} Agendamentos',
  'Select owner': 'Selecione o proprietário',
  'Generated on': 'Gerado em',
  'Favourite report': 'Favoritar relatório',
  'The report will be saved according to the previously activated filters.': 'O relatório será salvou de acordo com os filtros ativados previamente.',
  'View Reports': 'Ver relatórios',
  'The report will be sent according to the previously activated filters.': 'O relatório será enviado de acordo com os filtros de relatório favorito.',
  'Are you sure you want to remove this report from your favourites?': 'Tem certeza de que deseja remover este relatório dos favoritos?',
  'Favourite report successfully created!': 'Relatório favorito criado com sucesso!',
  'Favourite report successfully edited!': 'Relatório favorito editado com sucesso!',
  'Favourite report successfully deleted!': 'Relatório favorito excluído com sucesso!',
  'Mark report as favourite': 'Marcar relatório como favorito',
  'Edit favourite report': 'Editar relatório favorito',
  Execute: 'Executar',
  'Password Policy': 'Política de Senha',
  'Datanomik Standard': 'Padrão Datanomik',
  Customized: 'Customizado',
  'Minimum characters': 'Mínimo de caracteres',
  characters: 'caracteres',
  'Password creation requirements:': 'Requerimentos para criação de senha:',
  'minimum uppercase character (A-Z)': 'mínimo de letra maiúscula (A-Z)',
  'minimum lowercase character (A-Z)': 'mínimo de letra minúscula (a-z)',
  'minimum number (0-9)': 'mínimo de número (0-9)',
  'minimum special symbol (*!%#$)': 'mínimo de símbolo especiais (*!%#$)',
  'Other requirements:': 'Outros requerimentos:',
  'Request the password exchange for each': 'Solicitar a troca da senha a cada',
  days: 'dias',
  'Login attempt': 'Tentativa de login',
  attempts: 'tentativas',
  'After the number of login attempts, the user will be blocked.': 'Após o numero de tentativas de login, o usuário será bloqueado.',
  'Inactivity on the platform': 'Inatividade na plataforma',
  'Maximum inactivity time before blocking use:': 'Tempo máximo de inatividade antes de bloquear um uso:',
  'After the days scheduled without access to the platform, the user must again request access to the administrator': 'Após os dias programado sem acesso a plataforma, o usuário deverá solicitar novamente o acesso para o administrador',
  'Password Policy updated succefully!': 'Política de senha atualizada com sucesso!',
  'Wrong minimun value': 'Valor mínimo errado',
  'Minimum value is 0': 'O valor mínimo é 0',
  Resend: 'Reenviar',
  'Report successfully resended!': 'Relatório resenhado com sucesso!',
  'Transaction By Account': 'Transações por Conta',
  'Accounting Transactions': 'Transações Contábeis',
  'Transaction by Account with Closing Day': 'Transações Por Dia de Fechamento da Conta',
  'Group of categories': 'Grupo de categorias',
  'Edit group': 'Editar grupo',
  'Edit category': 'Editar categoria',
  'Add group': 'Adicionar grupo',
  'Login logs': 'Registro de atividades',
  'Log user': 'Usuário',
  'Login Date': 'Login',
  'Logout Date': 'Logout',
  'Activity log history': 'Histórico de atividades',
  'Session ID': 'Id de sessão',
  Session: 'Sessão',
  Strategic: 'Estratégica',
  'Strategic Treasury': 'Tesouraria Estratégica',
  'Analytical Treasury': 'Tesouraria Analítica',
  'Smart Cash Pilot': 'Piloto de Caixa Inteligente',
  'Low performance': 'Baixo desempenho',
  'Efficiency Score': 'Eficiência financeira',
  'Portfolio Performance': 'Remuneração do portfólio',
  'PERFECT!': 'Perfeito!',
  HIGH: 'Alto',
  MEDIUM: 'Médio',
  LOW: 'Baixo',
  'Represents the percentage of invested cash.': 'Representa a porcentagem de caixa investido.',
  'This section shows the sum of the net values of all investments, current balances and automatic applications.': 'Esta seção apresenta a soma dos valores líquidos de todos os investimentos, saldos correntes e aplicações automáticas.',
  'Represents the percentage of remuneration of fixed-income investments.': 'Representa a porcentagem da remuneração dos investimentos em renda fixa, em relação ao CDI.',
  'This graph displays the invested cash position by type of investment.': 'Este gráfico apresenta a posição de caixa investida por tipo de investimento.',
  'This graph displays investments to expire within a range of future dates.': 'Este gráfico apresenta o vencimento dos investimentos em um intervalo de datas futuras.',
  'This graph displays the daily evolution of credits and debits within a future date range.': 'Este gráfico apresenta a evolução diária de créditos e débitos em um intervalo de datas futuras.',
  'Future Cash': 'Capital de giro futuro',
  'Account status': 'Status das contas',
  'This section presents the status of the accounts with respect to balances and automatic applications, compared to the established cash limits.': 'Esta seção exibe o status atual das contas, incluindo saldos e aplicações automáticas, em comparação com os limites de caixa estabelecidos',
  'Potential of gain in the remuneration account {{currency}} {{value}}': 'Potencial de ganho na Conta Remunerada {{currency}} {{value}}',
  'Accounts ({{count}})': 'Contas ({{count}})',
  'Enable recurrence': 'Habilitar recorrência',
  'We will send every {{periodDay}} at {{periodTime}}h.': 'Iremos enviar todas {{periodDay}} às {{periodTime}}h.',
  '{{periodDay}} at {{periodTime}}h.': '{{periodDay}} às {{periodTime}}h.',
  'at {{periodTime}}h.': 'às {{periodTime}}h.',
  MONDAY: 'Segunda-feira',
  TUESDAY: 'Terça-feira',
  WEDNESDAY: 'Quarta-feira',
  THURSDAY: 'Quinta-feira',
  FRIDAY: 'Sexta-feira',
  'Weekly days': 'Dias semanais',
  'Best rescue option': 'Melhor opção de resgate',
  'Exit fullscreen': 'Sair da tela inteira',
  Fullscreen: 'Tela completa',
  Analytic: 'Analítica',
  UNCATEGORIZED: 'Sem categoria',
  TYPE_BATCH: 'SISPAG',
  TYPE_PIX: 'PIX',
  TYPE_TICKET: 'BOLETO',
  TYPE_SERVICE: 'SERVIÇO',
  TYPE_TED: 'TED',
  TYPE_DOC: 'DOC',
  TYPE_OTHER: 'OUTRO',
  'Select view': 'Selecione a visualização',
  'View list': 'Lista de visualizações',
  'The view will be created based on the previously applied filters.': 'A visualização será criada de acordo com os filtros aplicados previamente.',
  'New view': 'Nova visualização',
  'Edit view': 'Editar visualização',
  'View management': 'Gerenciamento de visualização',
  'View successfully created!': 'Visualização criada com sucesso!',
  'View successfully edited!': 'Visualização salva com sucesso!',
  'View successfully saved!': 'Visualização salva com sucesso!',
  'Are you sure you want to remove this View?': 'Tem certeza de que deseja remover esta visualização?',
  'View successfully deleted!': 'Visualização excluída com sucesso!',
  'Consolidated view of balances': 'Visão consolidada dos saldos',
  'net surplus': 'excedente líquido',
  'Remaining balance to cover': 'Saldo restante a cobrir',
  '{{count}} days_one': '{{count}} dia',
  '{{count}} days_other': '{{count}} dias',
  'New simulation': 'Nova simulação',
  Simulation: 'Simulação',
  'Investment simulation': 'Simulação de investimento',
  Calculate: 'Calcular',
  'Perform new simulation': 'Fazer nova simulação',
  'Value to be invested': 'Valor a ser investido',
  'Investment option': 'Opção de investimento',
  'Above 30 days the best option would be CDB.': 'Acima de 30 dias a melhor opção seria CDB.',
  'For a term of less than 30 days, the best option is a Committed.': 'Para um prazo de menos de 30 dias, a melhor opção é uma Compromissada.',
  'Remuneration (% of DI)': 'Remuneração (% do DI)',
  'DI Rate (%)': 'Taxa DI (%)',
  'IOF tax (%)': 'Imposto IOF (%)',
  'IR tax (%)': 'Imposto IR (%)',
  'Expected investment value': 'Valor do investimento previsto',
  Term: 'Prazo',
  'Potential financial gain (net)': 'Potencial ganho financeiro (líquido)',
  'DI Rate': 'Taxa DI',
  'Gross gain': 'Ganho bruto',
  'IOF tax': 'Imposto IOF',
  'IR tax': 'Imposto IR',
  'Net gain': 'Ganho lìquido',
  'Net profitability': 'Rentabilidade líquida',
  'Deadline days': 'Dias de prazo',
  'Expiration date': 'Data vencimento',
  'Some links were not fully updated or they have not been updated since yesterday, affecting the information available on the platform. Please try to synchronize them again.': 'Alguns links não foram atualizados completamente ou eles não foram atualizados desde ontem, afetando as informações disponíveis na plataforma. Por favor, tente sincronizá-los novamente.',
  'Synchronize now': 'Sincronizar agora',
  'Are you sure you want to synchronize them again?': 'Tem certeza de que deseja sincronizá-los novamente?',
  'Transaction value': 'Valor da transação',
  Union: 'União',
  Intersection: 'Interseção',
  'Double click to edit': 'Clique duas vezes para editar',
  'Workspace user status': 'Status espaço de trabalho',
  'Total categories amount must match with': 'O valor total das categorias deve corresponder com',
  DEFAULT: 'Padrão',
  View: 'Visualização',
  Views: 'Visualizações',
  'Payments to suppliers': 'Pagamento a fornecedores',
  Optimization: 'Otimização',
  'Cash flow evolution': 'Evolução do fluxo de caixa',
  Withdrawals: 'Resgates',
  'Liquidity index': 'Indicador de liquidez',
  'This graph shows how the cash flow evolves, separating the information between working capital and the evolution of investments and withdrawals. The Liquidity Index provides insight into the ability to meet short-term financial obligations and manage cash flow effectively.': 'Esse gráfico apresenta como o fluxo de caixa evolui, separando as informações entre o capital de giro e a evolução dos investimentos e resgates. O Indicador de Liquidez fornece informações sobre a capacidade de cumprir com as obrigações financeiras de curto prazo e gerenciar o fluxo de caixa de maneira eficaz.',
  'Depending on the availability of the Banks, statements may be available up to the 5th business day.': 'Dependendo da disponibilidade dos bancos, os extratos podem estar disponíveis até o quinto dia útil.',
  'Download type': 'Tipo de descarregamento',
  FILE_LIST_DOWNLOAD_TYPE_DEFAULT: 'Por padrão',
  FILE_LIST_DOWNLOAD_TYPE_NONE: 'Sem agrupamento',
  FILE_LIST_DOWNLOAD_TYPE_OWNER: 'Agrupado por proprietário',
  'Consolidated view by Owner': 'Visão consolidada por Proprietário',
  'Surplus balance': 'Saldo excedente',
  'Balance to cover': 'Saldo a cobrir',
  'Negative balance': 'Saldo negativo',
  'Consolidated balance': 'Saldo consolidado',
  'Consolidated value': 'Valor consolidado',
  Withdraw: 'Resgatar',
  'View all applications': 'Visualizar todas aplicações',
  'Insufficient investment position to cover the accounts of this owner.': 'Posição de investimento insuficiente para cobrir as contas desse proprietário.',
  'Transaction Type': 'Tipo de transação',
  'Add view': 'Criar visualização',
  'Personalize the dashboard visualization, identify trends, and make strategic decisions based on accurate and up-to-date information.': 'Personalize a visualização do dashboard, identifique tendências e tome decisões estratégicas com base em informações precisas e atualizadas.',
  'Give a name to this visualization': 'Dê um nome para esta visualização',
  'Choose the criteria for visualization': 'Escolha os critérios para visualização',
  'The defined criteria will be the basis for the platform\'s visualization.': 'Os critérios definidos serão a base para a visualização da plataforma.',
  'Choose the users who will have access to this visualization': 'Escolha os usuários que terão acesso a esta visualização',
  'The users will have "Read-only" permissions to access this visualization.': 'Os usuários terão permissões de ”Somente leitura" para acessar esta visualização.',
  'You can create a custom criterias to sort the applications.': 'Você pode criar critérios personalizados para ordenar as aplicações.',
  'Portfolio performance': 'Desempenho do portfólio',
  Portfolio: 'Portfólio',
  Loss: 'Perdida',
  GENERAL_PORTFOLIO_PERFORMANCE_INFO_TEXT: 'Esse gráfico apresenta o desempenho mensal da carteira de investimentos em comparação com a taxa DI e a inflação de cada mês.',
  'Remember to configure the following email to send the statements to be processed automatically:': 'Lembre-se de configurar o seguinte e-mail para enviar os extratos a serem processados automaticamente:',
  'Enter the decryption key for the email.': 'Digite a chave de descriptografia do e-mail.',
  'You have "Manual" and/or "Open Finance" links that have not been updated yet. Please remember that they need to be updated manually.': 'Você possui links do tipo "Manual" e/ou "Open Finance" que não foram atualizados ainda. Lembre-se de que eles precisam ser atualizados manualmente.',
  'Additionally, please remember that the "Manual" and "Open Finance" links need to be updated manually.': 'Além disso, lembre-se de que os links do tipo "Manual" e "Open Finance" precisam ser atualizados manualmente.',
  'Expiration detail': 'Detalhes do vencimento',
  'External id': 'Id externo',
  'My views': 'Meus visualizações',
  'Please note that the account list will be updated. This may involve adding new accounts and removing those that no longer exist in the Institution.': 'Por favor, esteja ciente que a lista de contas será atualizada. Isso pode implicar a adição de novas contas e a exclusão daquelas que não existem mais na Instituição.',
  'Do you agree to continue?': 'Deseja continuar?',
  'Connecting Accounts': 'Conectando contas',
  'Welcome to the new era of Intelligent Treasury': 'Bem-vindo à nova era da <2>Tesouraria Inteligente</2>',
  'Understand your company\'s cash flow and make strategic decisions.': 'Entenda o caixa da sua empresa e tome decisões estratégicas.',
  'Start now': 'Começar agora',
  'Defining Company Profile': 'Definindo perfil da empresa',
  'Cash Opening and Closing': 'Abertura e fechamento de caixa',
  'This information will define the update time of links.': 'Essa informação definirá o horário de atualização dos links.',
  'Choose the cash opening hours': 'Escolha o horário de abertura de caixa',
  hour: 'hora',
  'Choose the cash closing time': 'Escolha o horário de fechamento de caixa',
  'Cash Management Limits and Goals': 'Limites e Metas da gestão de caixa',
  'Minimum cash limit': 'Limite de caixa mínimo',
  'Maximum cash limit': 'Limite de caixa máximo',
  'Financial efficiency goal': 'Meta de eficiência financeira',
  'Portfolio performance target': 'Meta de desempenho do portfolio',
  '(fixed income)': '(renda fixa)',
  'Let\'s start?': 'Vamos começar?',
  'To connect': 'Conectar',
  Attention: 'Atenção',
  'During the registration period of the links, we ask you not to access the internet banking until our dashboard is updated. This will ensure the safety and integrity of your information. Thank you for understanding!': 'Durante o período de cadastro dos links, pedimos que não acesse o internet banking até que nosso dashboard seja atualizado. Isso garantirá a segurança e a integridade das suas informações. Obrigado pela compreensão!',
  'Invite users to use the platform': 'Convide usuários para utilizar a plataforma',
  Synchronizing: 'Sincronizando',
  'Company settings successfully saved!': 'As configurações da empresa salvaram com sucesso!',
  'Efficiency Analysis: {{mondayLastWeek}} - {{fridayLastWeek}}': '<0>Análise de eficiência:</0> {{mondayLastWeek}} - {{fridayLastWeek}}',
  'Efficiency Analysis': 'Análise de eficiência',
  'Period: {{mondayLastWeek}} - {{fridayLastWeek}}': '<0>Período:</0> {{mondayLastWeek}} - {{fridayLastWeek}}',
  'Period: {{dateFrom}} - {{dateTo}}': '<0>Período:</0> {{dateFrom}} - {{dateTo}}',
  'Scope: {{ totalCompleted }} owners analyzed (out of {{ total }})': '<0>Alcance:</0> {{ totalCompleted }} proprietários analisados (de um total de {{ total }})',
  'General efficiency': 'Eficiência Geral',
  'Daily average': 'Média diária',
  'Indicates the overall efficiency of cash flow management during the analyzed week.': 'Indica a eficiência geral da gestão do fluxo de caixa durante a semana analisada.',
  'Liquidity indicator': 'Indicador de liquidez',
  'Provides information on the ability to meet short-term financial obligations and manage cash flow effectively. It calculates the daily average of the comparison between the total credits and investment withdrawals with the total debits of each day.': 'Proporciona informações sobre a capacidade de cumprir com as obrigações financeiras de curto prazo e gerenciar o fluxo de caixa de maneira eficaz. Calcula a média diária da comparação entre o total de créditos e resgates com o total de débitos de cada dia.',
  'Profit opportunity': 'Oportunidade de ganhos',
  'Additional liquid': 'Líquido adicional',
  'It represents the opportunity to generate additional financial income as a result of the cash flow optimization opportunities detected by the Smart Cash Pilot.': 'Representa a oportunidade de gerar receita financeira adicional como resultado das oportunidades de otimização do fluxo de caixa detectadas pelo Piloto de Caixa Inteligente.',
  'Efficiency Planning': 'Eficiência do planejamento',
  'This section presents the cash management for the analyzed week and compares it with the results of the Smart Cash Pilot management.': 'Esta seção apresenta a gestão de caixa da semana analisada e a compara com o resultado da gestão do Piloto de Caixa Inteligente.',
  'Model Optimization': 'Piloto de Caixa Inteligente',
  'Improvement opportunities': 'Oportunidades de melhoria',
  'Additional Gain Opportunities': 'Oportunidades de ganhos adicionais',
  'Minimum Cash Analysis': 'Análise da caixa minima',
  'Ok, continue': 'Ok, continuar',
  Categorize: 'Categorizar',
  'Massive categorization': 'Categorização em massa',
  'Transactions successfully saved!': 'Transações salvas com sucesso!',
  'Pix successfully saved!': 'Pix salvos com sucesso!',
  'Payments successfully saved!': 'Pagamentos salvos com sucesso!',
  'Hello, {{name}}': 'Olá, {{name}}',
  'Cash management': 'Gestão de caixa',
  'Banking institutions': 'Instituições bancárias',
  '{{name}}, what is your area and function in the company?': '{{name}}, qual sua área e função na empresa?',
  'Invitation sent': 'Convite enviado',
  'Area of action': 'Área de atuação',
  'Function / Position': 'Função / Cargo',
  Financial: 'Financeiro',
  Treasury: 'Tesouraria',
  'Accounts payable': 'Contas a pagar',
  'Accounts receivable': 'Contas a receber',
  Accounting: 'Contabilidade',
  'FP&A': 'FP&A',
  Analyst: 'Analista',
  Coordinator: 'Coordenador',
  Manager: 'Gerente',
  Director: 'Diretor',
  Specialist: 'Especialista',
  Process: 'Processo',
  'Cash opening': 'Abertura de caixa',
  'Cash closing': 'Fechamento de caixa',
  'Cash analysis frequency': 'Frequência de análise do caixa',
  Policies: 'Políticas',
  Liquidity: 'Liquidez',
  Products: 'Produtos',
  'Choose the day of the week': 'Escolha o dia da semana',
  DDA: 'Direito de Arena',
  'Analytical summary of the week: {{mondayLastWeek}} - {{fridayLastWeek}}': '<0>Resumo analítico da semana:</0> {{mondayLastWeek}} - {{fridayLastWeek}}',
  'Analytical Summary': 'Resumo Analítico',
  'Position Investments': 'Posição Investimentos',
  'Financial movement': 'Movimentação financeira',
  'You had {{count}} accounts with negative balance': 'Você teve <2>{{count}}</2> contas com saldo negativo',
  'Expected interest *': 'Juros previstos *',
  'Oldest application date': 'Data mais antiga de aplicação',
  'Incompleted sync': 'Atualização incompleta',
  'label.investmentsAppByMonthCustom': 'Relatório Executivo',
  'Account from': 'Dê',
  'Account to': 'Para',
  'Day and hour': 'Dia e hora',
  'Created by': 'Realizado por',
  'Transfer created successfully!': 'Transferência criada com sucesso!',
  'New transfer': 'Nova transferência',
  'Search account': 'Procurar conta',
  'Ok, close': 'Ok, fechar',
  Transfers: 'Transferências',
  TRANSFER_FAILED: 'Fracassada',
  TRANSFER_REJECTED: 'Rejeitada',
  TRANSFER_REQUESTED: 'Processando',
  TRANSFER_CONFIRMED: 'Concluída',
  TRANSFER_PENDING: 'Pendente',
  TRANSFER_AWAITING_APPROVAL: 'Aguardando aprovação',
  TRANSFER_APPROVED: 'Aprovada',
  TRANSFER_REPROVED: 'Reprovada',
  TRANSFER_REQUESTED_WITH_ERROR: 'Com error',
  TRANSFER_PENDING_CONFIRMATION: 'Confirmação pendente',
  "Transfer's detail": 'Detalhes da transferência',
  'Pix created successfully': 'Pix criado com sucesso',
  'Pix may take a few minutes to complete. Follow the status in the table below.': 'O Pix pode demorar alguns minutos para ser concluído. Acompanhe o status na tabela abaixo.',
  'Confirm your pix transfer': 'Confirme sua transferência Pix',
  BLOCKED_JUDICIAL: 'Saldo bloqueado judicialmente',
  'Registration status': 'Status de registro',
  'label.dailyBalancesByOwner': 'Saldos diários (por proprietários)',
  'Pix key': 'Chave pix',
  key: 'chave',
  'key type': 'tipo de chave',
  RANDOM: 'Aleatória',
  PHONE: 'Celular',
  'Calculates the average of the daily ratio that compares the total credits/withdrawals with the total debits/investments.': 'Calcula a média diária da comparação do total de créditos/resgates com o total de débitos/aplicações.',
  '30-day projection': 'Projetado para 30 dias',
  'Investment order submitted': 'Ordem de investimento enviada',
  'The invested amount will be blocked until the process finishes.': 'O valor investido ficará bloqueado até que o processo finalize.',
  'In Analysis': 'Em análise',
  'New investment': 'Novo investimento',
  'Confirm your investment': 'Confirme seu investimento',
  'Inlcude attachments': 'Incluir anexos',
  'Money movement': 'Movimentar dinheiro',
  Transfer: 'Transferir',
  'Invest / Withdraw': 'Investir / Resgatar',
  'Manual transactions': 'Transações manuais',
  'Manual transactions (Upload file)': 'Transações manuais (Subir arquivo)',
  'Manual positions': 'Posições manuais',
  'Automatic application (balance)': 'Aplicação automática (saldo)',
  'Automatic application': 'Aplicação automática',
  'Committed (net value)': 'Compromissadas (saldo líquido)',
  'CDBs (net value)': 'CDBs (saldo líquido)',
  'Funds (net value)': 'Fundos (saldo líquido)',
  Funds: 'Fundos',
  'Values successfully saved!': 'Valores salvos com sucesso!',
  'Check the details of your investments or make a withdrawal quickly and easily.': 'Consulte os detalhes dos seus investimentos ou realize o resgate de forma simples e rápida.',
  'Investment history': 'Histórico de investimentos',
  'New withdraw': 'Novo resgate',
  'Net value available': 'Valor líquido disponível',
  'Destination account': 'Conta destino',
  'Rescue details': 'Detalhes do resgate',
  'Withdrawal amount': 'Valor do resgate',
  'Confirm your withdraw': 'Confirme seu resgate',
  'Successful rescue order': 'Ordem de resgate criada com sucesso',
  FIXED_INCOME: 'Renda fixa',
  'Last Sync Time': 'Última sincronização',
  'No previous updates': 'Sem atualizações anteriores',
  'Investments - deposit': 'Investimentos - CDB',
  'Investments - committed': 'Investimentos - Compromissada',
  'Investments - fund': 'Investimentos - Fundo',
  'See totals': 'Veja totais',
  'Click on bar to see details': 'Clique na barra para ver os detalhes',
  subCategory: 'Sub categoria',
  'Sub category': 'Sub categoria',
  'Which banks are included?': 'Quais bancos estão inclusos?',
  'Check out the table of available banks and extracts': 'Confira a tabela dos bancos e extratos disponíveis',
  'Checking account': 'Conta corrente',
  'Transaction Categories Fees Per Month': 'Taxas de Categorias de Transação por Mês',
  'Projected annual': 'Projetado anual',
  'Annual goal': 'Meta anual',
  'Cashflow manual entries': 'Fluxo de caixa (Entradas manuais)',
  'Discard all changes': 'Descartar todas as mudanças',
  'Discard changes': 'Descartar as mudanças',
  'Cashflow manual entries successfully saved!': 'Entradas manuais de fluxo de caixa salvas com sucesso!',
  'Subcategory Type': 'Tipo do Título',
  'Fixed Income Details': 'Detalhes da Renda Fixa',
  'All year': 'Todo ano',
  Print: 'Imprimir',
  'Working capital': 'Capital de giro',
  'Analysis by Institution': 'Análise por Instituição',
  'Additional information': 'Informações adicionais',
  'Average compensation CDI': 'Remuneração média CDI',
  'Balance + Automatic Applications': 'Saldo + Aplicações automáticas',
  'label.monthlyAnalyticalOverview': 'Visão Analítica - Foto do Mês',
  'Enter your details to login.': 'Digite seus dados para fazer login.',
  'Please enter a valid email address': 'Digite um e-mail válido',
  'Create a new password': 'Crie uma nova senha',
  'Set up a secure password to protect your account.': 'Configure uma senha segura para proteger sua conta.',
  'Enter your details to active.': 'Digite seus dados para ativar.',
  'Accept the use': 'Aceitar o uso',
  'Please enter a valid phone number': 'Por favor, insira um número de telefone válido',
  Example: 'Exemplo',
  'Area activity': 'Área de atividade',
  'label.balancesModel': 'Posições diárias',
  'Customer Reference': 'Referência do Cliente',
  'Overdraft limit check': 'Limite cheque especial',
  'label.investmentsDailyPosition': 'Posição Diária de Investimentos',
  'label.dailyBalancesWithChart': 'Saldos diários com gráficos',
  'label.monthlyInvestmentPerformance': 'Desempenho Mensal de Investimentos',
  'All applied rules reflect data from the last 7 days.': 'Todas as regras aplicadas refletem dados dos últimos 7 dias.',
  Debts: 'Dividas',
  'IOF Exempt Balance': 'Saldo Liquido Livre de IOF',
  'Please review and accept to continue using our services.': 'Por favor, revise e aceite para continuar utilizando nossos serviços.',
  'User activated succefully!': 'Usuário ativado com sucesso!',
  'Terms and Conditions accepted succefully!': 'Termos e condições aceitos com sucesso!',
  'label.dailyInvestmentPerformance': 'Rentabilidade diária do investimentos',
  'Browse between categories': 'Navegue entre as categorias',
  'Follow your company\'s all financial position': 'Acompanhe toda posição financeira da sua empresa',
  'Follow the status of all your bank connections': 'Acompanhe o status de todas suas conexões bancárias',
  'Clear and up-to-date view of cash positions for strategic financial management': 'Visão clara e atualizada das posições de caixa para uma gestão financeira estratégica',
  'Follow your portfolio': 'Acompanhe seu portfólio',
  'Follow your financial transactions': 'Acompanhe suas transações financeiras',
  'Search client': 'Buscar cliente',
  'Copy ID': 'Cópia ID',
  'Loading information': 'Carregando informações',
  'View investments': 'Visualizar investimentos',
  'View cash pilot': 'Visualizar piloto de caixa',
  'Initiation type': 'Tipo de iniciação',
  'label.pixTransactions': 'Pix',
  'label.paymentsAndPixTransactions': 'Pagamentos e Pix',
  'Regenerate Transaction Summary': 'Regenerar Resumo da Transação',
  'Display document': 'Documento personalizado',
  'First quarter': 'Primeiro quarto',
  'Second quarter': 'Segundo quarto',
  'Third quarter': 'Terceiro quarto',
  'Fourth quarter': 'Quarto quarto',
  Quarter: 'Quarto',
  'label.quarter01': 'Otimização de Caixa',
  'label.quarter02': 'Concentração Bancária',
  'label.quarter03': 'Movimento de Caixa',
  'label.datanomik': 'Datanomik',
  'My extracts': 'Meus extratos',
  'Extract status': 'Status do extrato',
  Formats: 'Formatos',
  'New extract': 'Novo Extrato',
  'Custom extracts may take up to 24 hours to process.': 'Extratos personalizados podem demorar até 24 horas para serem processados.',
  'Add a description': 'Adicione uma descrição',
  'Choose a link': 'Escolha um Link',
  'Status of available extracts': 'Status dos extratos disponíveis',
  'Status of available downloads': 'Status dos downloads disponíveis',
  Extracts: 'Extratos',
  'Download available': 'Baixar disponíveis',
  'Last 7 Days': 'Últimos 7 dias',
  'Last 30 Days': 'Últimos 30 dias',
  'Current Month': 'Mês atual',
  'Prev Month': 'Mês Anterior',
  'The initial date is required': 'A data inicial é necessária',
  'The final date is required': 'A data final é necessária',
  'Download completed successfully!': 'Download concluído com sucesso!',
  'Period statement execution created succefully!': 'Execução de extrato por período criada com sucesso!',
  'label.periodStatementExecutions': 'Execuções de extrato por período',
  'Period statement executions': 'Execuções de extrato por período',
  Payment: 'Pagamento',
  'Edit payment categories': 'Editar categorias de pagamento',
  'Edit pix categories': 'Editar categorias de pix',
  Overdraft: 'Sobregiro',
  'Recategorize Transactions': 'Recategorizar Transações',
  'Categorization types': 'Tipos de categorização',
  'In progress extracts': 'Em progresso e pendentes:',
  'Failed extracts': 'Falhados:',
  'Completed extracts': 'Concluídos:',
  'In progress statement process': 'Processo de obtenção em progresso:',
  'Pending statement process': 'Processo de obtenção pendente:',
  'Completed statement process': 'Processo de obtenção concluído:',
  Executions: 'Execuções',
  'Download status': 'Status do download',
  'My reports': 'Meus relatórios',
  CUSTOM: 'Personalizada',
  'Types of investments': 'Tipos de investimentos',
  'Check out all types of investments in your portfolio': 'Confira todos os tipos de investimentos do seu portfólio',
  'Gross profitability': 'Rentabilidade bruta',
  Details: 'Detalhes',
  'Total balance': 'Saldo total',
  'Close to maturity': 'Próximo ao vencimento',
  'Distribution by liquidity': 'Distribuição por liquidez',
  'Investments by institutions': 'Investimentos por instituições',
  'Evolution of total investment': 'Evolução do investimento total',
  Day: 'Dia',
  Week: 'Semana',
  'Total investment': 'Investimento total',
  'Gross profit.': 'Rent. bruta',
  'Net profit.': 'Rent. líquida',
  'Performance CDI': 'Performance CDI',
  'Gross accumulated profitability': 'Rentabilidade acumulada bruta',
  'Month movements': 'Movimentações do mês',
  movementInflow: 'Entrada',
  movementOutflow: 'Retirada',
  'Commercial dollar': 'Dólar comercial',
  'Clone view': 'Clone visualização',
  'Fixed income investment': 'Investimento renda fixa',
  'Committed investment': 'Investimento compromissada',
  'COE investment': 'Investimento COE',
  'Fund investment': 'Fundos de investimentos',
  'Gross yield': 'Rendimento bruto',
  'Total Last month': 'Acumulado do mês anterior',
  Accumulated: 'Acumulado do mês atual',
  'CDBs deadlines': 'Prazos dos CDBs',
  'Committed deadlines': 'Prazos das compromissadas',
  'Diversification of fixed income': 'Diversificação da Renda Fixa',
  'Diversification of committed': 'Diversificação das Compromissadas',
  'Diversification of investment funds': 'Diversificação dos Fundos de investimentos',
  'Total gross expiration': 'Total bruto por vencimento',
  'Types present in the wallet': 'Tipos presentes na carteira',
  'Funds present in the wallet': 'Fundos presentes na carteira',
  'Committed days': 'Dias compromissadas',
  'Generate Monthly': 'Gerar extratos bancários mensais',
  'Unsaved changes': 'Alterações não salvas',
  'You have unsaved changes. Do you want to save them before closing?': 'Você tem alterações não salvas. Deseja salvá-las antes de fechar?',
  'Position of applications': 'Posição das aplicações',
  Application: 'Aplicação',
  Allocation: 'Alocação',
  'Purchase date': 'Data compra',
  Purchase: 'Compra',
  Maturity: 'Vencimento',
  '# note': '# da nota',
  'Purchase rate': 'Taxa da compra',
  'All institutions': 'Todas as instituições',
  'All owners': 'Todos os proprietários',
  'Net amount': 'Saldo líquido',
  'Total net': 'Total líquido',
  'Set the minimum CDI percentage expected by type of investment and the ideal maximum deadline for committed.': 'Defina o porcentual mínimo do CDI esperado por tipo de investimento e o prazo máximo ideal para compromissadas.',
  'Maximum period in Committed': 'Prazo máximo em Compromissadas',
  'applied days': 'dias aplicados',
  'Applications CDB': 'Aplicações CDB',
  'Applications Committed': 'Aplicações Compromissadas',
  'Applications Funds': 'Aplicações Fundos',
  'Applications COE': 'Aplicações COE',
  'Application details': 'Detalhes da aplicação',
  'Over {{days}} days applied': 'Acima de {{days}} dias aplicada',
  'CDI is below {{cdi}}%': 'CDI está abaixo {{cdi}}%',
  'Set minimum and/or maximum cash limits for the selected accounts': 'Defina limites de caixa mínimo e/ou máximo para as contas selecionadas',
  'No application with maturity for today.': 'Nenhuma aplicação com vencimento para hoje.',
  'No application with maturity.': 'Nenhuma aplicação com vencimento.',
  'Next maturity': 'Próximo vencimento',
  '{{total}} applications': '{{total}} aplicações',
  '1 application': '1 aplicação',
  'No application with low performance': 'Nenhuma aplicação com baixa performance',
  'Learn more in settings': 'Saiba mais em configurações',
  'Payment controller': 'Controlador de pagamento',
  PAYMENT_CONTROLLER: 'Controlador de pagamento',
  XP_OF: 'XP',
  CAIXA: 'Caixa',
  BRADESCO_OF: 'Bradesco',
  ITAU_OF: 'Itaú',
  SANTANDER_OF: 'Santander',
  BV_OF: 'BV',
  BTG_PACTUAL_CORP: 'BTG',
  CAIXA_READONLY: 'Caixa',
  UNICRED_OF: 'Unicred',
  BANCO_BRASIL_OF: 'Banco do Brasil',
  NORDESTE: 'Nordeste',
  SOFISA: 'Sofisa',
  STARK_BANK: 'Stark Bank',
  AGORA_OF: 'Agora',
  BTG_EMPRESAS_OF: 'BTG',
  SICREDI: 'Sicredi',
  AGORAINVESTIMENTOS: 'Agora Investimentos',
  XP: 'XP',
  SOFISA_OF: 'Sofisa',
  SAFRA: 'Safra',
  ITAU_WEB: 'Itaú',
  BANRISUL: 'Banrisul',
  ABC: 'ABC',
  BANCO_RENDIMENTO_OF: 'Banco Rendimento',
  C6_OF: 'C6',
  PINE: 'Pine',
  BTG_INVESTMENT_OF: 'BTG',
  CAIXA_OF: 'Caixa',
  SICOOB: 'Sicoob',
  SANTANDER: 'Santander',
  BRADESCO: 'Bradesco',
  'label.allInstrumentMovements': 'Movimentação de Investimentos - todos os instrumentos',
  'Some of the selected payments are older than 3 months and will not be requested.': 'Alguns dos pagamentos selecionados têm mais de 3 meses e não serão solicitados.',
  'Owners and Accounts': 'Proprietários e Contas',
  'You are in the default view. Deleting this category here will permanently remove it from the entire system, including all other views.': 'Você está na visualização padrão. Excluir esta categoria aqui também a removerá permanentemente do sistema, incluindo todas as outras visualizações.',
  'Type the name of the category to confirm deletion:': 'Digite o nome da categoria para confirmar a exclusão:',
  'Are you sure you want to delete this category group?': 'Tem certeza de que deseja excluir este grupo de categorias? Todas as categorias associadas a este grupo serão movidas para o grupo "Outros".',
  'label.investmentsPortfolio': 'Portfólio de investimentos',
  'Investments Portfolio.': 'Portfólio de investimentos.',
  'Statement format': 'Formato do extrato',
  'Choose statement format': 'Escolha o formato do extrato',
  'Only PDF': 'Apenas PDF',
  'Only OFX': 'Apenas OFX',
  'PDF and OFX': 'PDF e OFX',
  'Conciliator ID': 'ID do Conciliador',
  Datetime: 'Data e hora',
  'Total investment performance': 'Performance do investimento total',
  'Monthly performance comparison': 'Comparativo de performance mensal',
  'Liquid profitability': 'Rentabilidade liquida',
  'CDI average': 'CDI médio',
  'IOF incident': 'IOF incidente',
  'IR average': 'IR médio',
  'IOF average': 'IOF médio',
  'Rescue index': 'Índice de resgate',
  'Asset performance': 'Performance do ativo',
  'Days average': 'Média dias',
  Support: 'Suporte',
  'Your Manager': 'Seu Gerente',
  'General Support': 'Suporte Geral',
  'Report a problem': 'Reportar um problema',
  'Open a ticket for the technical team': 'Abrir um chamado para a equipe técnica',
  'Report.action': 'Reportar',
  Documentation: 'Documentação',
  'Check out how to integrate our APIs': 'Veja como integrar nossas APIs',
  Open: 'Abrir',
  'Suggestions & Improvements': 'Sugestões e Melhorias',
  'Send us your idea': 'Envie sua ideia',
  Suggest: 'Sugerir',
  'We want to hear from you': 'Queremos ouvir você',
  ZenDesk: 'ZenDesk',
  'Create and manage your tickets': 'Crie e gerencie seus tickets',
  'Talk to support': 'Falar com Suporte',
  'Open In Web': 'Abrir na Web',
  'Support Hours': 'Atendimento',
  'Monday to Friday from 9am to 6pm.': 'Segunda à Sexta das 9 às 18hrs.',
  'Scan the QR Code with your phone': 'Leia o QR Code com seu celular',
  'Describe your idea': 'Descreva sua ideia',
  'Type your suggestion here...': 'Digite sua sugestão aqui...',
  'This field is required': 'Este campo é obrigatório',
  'The suggestion must be at least 10 characters long': 'A sugestão deve ter pelo menos 10 caracteres',
  Send: 'Enviar',
  'label.dailyConciliation': 'Conciliação diária',
  'Thank you for your suggestion!': 'Obrigado pela sua sugestão!',
  'Your feedback helps us improve our service.': 'Seu feedback nos ajuda a melhorar nosso serviço.',
  ITAU_BBA: 'Itaú BBA',
  MERCURY: 'Mercury',
  JEEVES: 'Jeeves',
  BREX: 'Brex',
  SVB: 'Silicon Valley',
  MORGAN_STANLEY: 'Morgan Stanley',
  SILICON_VALLEY: 'Silicon Valley',
  'Validating login to {{institution}}': 'Validando o login na {{institution}}',
  'See less': 'Ver menos',
  more: 'mais',
  'Projected percentage': 'Porcentual projetado',
  'label.dailyCashStatement': 'Relação de caixa diário',
  'label.accountsBalanceErp': 'Saldo de contas - ERP',
  'Profitability and gain month by month': 'Rentabilidade e ganho mês a mês',
  'Monthly asset evolution': 'Evolução do ativo mensal',
  'Average annual CDI Performance': 'Performance média anual CDI',
  'Annual profitability': 'Rentabilidade anual',
  'Investment comparator': 'Comparador de investimento',
  'Deadline for rescue': 'Prazo para resgate',
  'Enter a value': 'Digite um valor',
  'Use idle balance': 'Usar saldo ocioso',
  'Investment Performance Analysis': 'Análise de Performance dos Investimentos',
  'DI return': 'Remuneração do DI',
  'Due date': 'Data de vencimento',
  Equilibrium: 'Ponto de equilíbrio',
  'Follow all about your investments': 'Acompanhe tudo sobre seus investimentos',
  // Bank Integrations
  'Bank Credentials': 'Credenciais bancárias',
  'Your credentials are encrypted and stored securely.': 'Suas credenciais são criptografadas e armazenadas de forma segura.',
  'Secure integration with your bank.': 'Integração segura com seu banco.',
  'To automate your transactions and connect your bank account to the platform, please enter the credentials provided by your bank.': 'Para automatizar suas transações e conectar sua conta bancária à plataforma, por favor insira as credenciais fornecidas pelo seu banco.',
  'New Credential': 'Nova Credencial',
  'Connect your bank credentials securely.': 'Conecte suas credenciais bancárias de forma segura.',
  'To carry out transactions automatically, we need you to enter the credentials provided by your bank. This information is used only to integrate your bank account and is not exposed at any time.': 'Para realizar transações automaticamente, precisamos que você insira as credenciais fornecidas pelo seu banco. Esta informação é usada apenas para integrar sua conta bancária e não é exposta em nenhum momento.',
  'No credentials registered for this bank': 'Nenhuma credencial registrada para este banco',
  '1 credential registered for this bank': '<b>1 credencial</b> registrada para este banco',
  '{{count}} credentials registered for this bank': '<b>{{count}} credenciais</b> registradas para este banco',
  'Public Certificate': 'Certificado público',
  'Private Certificate': 'Certificado privado',
  'Client Secret': 'Segredo do cliente',
  'Client ID': 'ID do cliente',
  'Api Key': 'Chave da API',
  'Create Credential': 'Criar Credencial',
  'Could not validate the data. Please confirm and try again.': 'Não foi possível validar os dados. Por favor, confirme e tente novamente.',
  Change: 'Alterar',
  Integrations: 'Integrações',
  Certificate: 'Certificado',
  Certificates: 'Certificados',
  'Certificate found': 'Certificado encontrado',
  'A1 Certificate': 'Certificado A1',
  'Replace Certificate': 'Substituir Certificado',
  'label.financialEfficiency': 'Eficiência Financeira',
  'Institution Client Id': 'ID do cliente',
  'Choose an institution': 'Escolha uma instituição',
  'Remuneration Account': 'Conta Remunerada',
  'label.applicationHistory': 'Histórico de aplicações',
  'Rejection reason': 'Razão de rejeição',
  Barcode: 'Código de barras',
  'Change to view mode': 'Mudar para modo de visualização',
  'Change to edit mode': 'Mudar para modo de edição',
  'Cashflow projected successfully saved!': 'Fluxo de caixa projetado salvo com sucesso!',
  'Manual cash flow (Upload file)': 'Fluxo de caixa manual (Subir arquivo)',
  'label.futureTransactions': 'Lançamentos futuros',
  'Edit purchase rate': 'Editar taxa da compra',
  'Purchase rate updated successfully': 'Taxa da compra atualizada com sucesso',
  'Go to Datanomik Treasury': 'Ir para Datanomik Treasury',
  'View transfer rules': 'Ver regras de transferência',
  'Transfer rules for remuneration account': 'Regras de transferência para conta remunerada',
  Rule: 'Regra',
  'Amount to transfer': 'Valor a transferir',
  'Fixed amount': 'Valor fixo',
  'Above amount': 'Acima de {{amount}}',
  'Excess amount': 'Valor excedente',
  'Accounts without statement': 'Contas sem extrato',
  'Without statement detail': 'Detalhe sem extrato',
  'With receipt': 'Com comprovante',
  '1 receipt requested': '1 comprovante solicitado',
  '{{count}} receipts requested': '{{count}} comprovantes solicitados',
  'Showing requested receipts': 'Mostrando comprovantes solicitados',
  'label.paymentSlips': 'Francesinhas',
  'Payment slips by account.': 'Francesinhas por conta.',
  'Payment slip': 'Francesinhas',
  PAYMENT_SLIP: 'Francesinhas',
  'Select or drop PFX file': 'Selecione ou arraste o arquivo PFX',
  'PFX Password': 'Senha do PFX',
  Validate: 'Validar',
  'Invalid PFX file': 'Arquivo PFX inválido',
  'Invalid password': 'Senha inválida',
  'Download all filtered payment receipts': 'Baixar todos os comprovantes filtrados',
  'Request all filtered payment receipts': 'Solicitar todos os comprovantes filtrados',
  'Cannot download more than 1000 payments receipts.': 'Não é possível baixar mais de 1000 comprovantes.',
  NEXT_DAY: 'Próximo dia',
  NEXT_WEEK: 'Próxima semana',
  NEXT_15_DAYS: 'Próximos 15 dias',
  NEXT_30_DAYS: 'Próximos 30 dias',
  NEXT_MONTH: 'Próximo mês',
};
